"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26227,66583,7596,13024],{

/***/ 71439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59375);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68826);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);





var educatorRouteRegex = new RegExp("^/educator/*");
var useActivityStats = function(goalUID) {
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().pathname;
    var isEducatorRoutes = educatorRouteRegex.test(pathname);
    var key = isEducatorRoutes ? null : "v2/gamification/user/activity_stats/?goal_uid=".concat(goalUID);
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(goalUID ? key : null), activityStats = _ref.data, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "data"
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        activityStats: activityStats || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (useActivityStats);


/***/ }),

/***/ 27200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);


/* eslint-disable react-hooks/exhaustive-deps */ 
var useGoalInfo = function(goalUID) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        selector: null,
        fallbackData: undefined
    };
    var key = "v1/topology/users/".concat(goalUID, "/self/");
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(goalUID ? key : null, {}, {
        fallbackData: options.fallbackData
    }), goalInfo = _ref.data, isValidating = _ref.isValidating, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, [
        "data",
        "isValidating"
    ]);
    if (options.selector && typeof options.selector === "function") return options.selector(goalInfo || {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        key: key,
        goalInfo: goalInfo,
        isValidating: isValidating
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (useGoalInfo);


/***/ }),

/***/ 46024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);



var useAutoCompleteResults = function(query) {
    var key = "v1/search/autocomplete/elaborated/3/?q=".concat(query);
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(query ? key : null), autoCompleteResults = _ref.data, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, [
        "data"
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        autoCompleteResults: query ? autoCompleteResults : []
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAutoCompleteResults);


/***/ }),

/***/ 74705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);



var usePopularSearches = function() {
    var key = "v1/search_v3/populars/";
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key), popularSearches = _ref.data, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, [
        "data"
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        popularSearches: popularSearches
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePopularSearches);


/***/ }),

/***/ 47154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);
/* harmony import */ var _api_processors_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26046);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73060);
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18113);
/* harmony import */ var _auth_useMyInfo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85780);







var useRecentSearches = function(goalUID) {
    var shouldFetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var key = "plus_search/home?goal_uid=".concat(goalUID, "&version=2");
    var isLoggedIn = (0,_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_4__/* .getIsLoggedIn */ .M7);
    var searchToken = (0,_utils_cookies__WEBPACK_IMPORTED_MODULE_2__/* .readCookie */ .vQ)("searchToken");
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(isLoggedIn && goalUID && searchToken && shouldFetch ? key : null, {
        useSearchToken: true,
        useAuthToken: false
    }), recentSearchesData = _ref.data, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, [
        "data"
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        recentSearches: (0,_api_processors_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(recentSearchesData)
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (useRecentSearches);


/***/ }),

/***/ 26046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getAuthorFullName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _models_User__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81570);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97428);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31309);
/* harmony import */ var _cont_Batch_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73993);








var separator = " \u2022 ";
var getAuthorFullName = function(author) {
    return (0,_models_User__WEBPACK_IMPORTED_MODULE_0__/* .getFullName */ .Pp)((0,_models_User__WEBPACK_IMPORTED_MODULE_0__/* .formatFirstName */ .ug)((author === null || author === void 0 ? void 0 : author.firstName) || ""), (author === null || author === void 0 ? void 0 : author.lastName) || "");
};
var getFormattedCount = function(count, text) {
    return count > 0 ? (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .pluralize */ ._6)(count, text) : "";
};
var getUserSubText = function(item) {
    var ref = (item === null || item === void 0 ? void 0 : item.data) || {}, followersCount = ref.followersCount, coursesCount = ref.coursesCount, isExEducator = ref.isExEducator, educatorTypeV2 = ref.educatorTypeV2;
    if (isExEducator) return "Ex-educator";
    if (educatorTypeV2 === _cont_Batch_utils__WEBPACK_IMPORTED_MODULE_4__/* .EDUCATOR_TYPES.PARTNER */ .MB.PARTNER) return "Partner Educator";
    return "".concat(getFormattedCount(followersCount, "follower")).concat(followersCount > 0 && coursesCount > 0 ? separator : "").concat(getFormattedCount(coursesCount, "course"));
};
var _obj;
var itemTypeFormatter = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .searchItemTypes.COURSE */ .tQ.COURSE, function(item) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return {
        as: item === null || item === void 0 ? void 0 : (ref = item.data) === null || ref === void 0 ? void 0 : (ref1 = ref.programme) === null || ref1 === void 0 ? void 0 : ref1.relativeLink,
        thumbnail: (item === null || item === void 0 ? void 0 : (ref2 = item.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.programme) === null || ref3 === void 0 ? void 0 : ref3.coverPhotoV1) || (item === null || item === void 0 ? void 0 : (ref4 = item.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.programme) === null || ref5 === void 0 ? void 0 : ref5.coverPhoto),
        name: item === null || item === void 0 ? void 0 : (ref6 = item.data) === null || ref6 === void 0 ? void 0 : ref6.name,
        subText: "By ".concat(getAuthorFullName(item === null || item === void 0 ? void 0 : (ref7 = item.data) === null || ref7 === void 0 ? void 0 : ref7.author))
    };
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .searchItemTypes.TEST_SERIES */ .tQ.TEST_SERIES, function(item) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var dateNow = new Date().getTime();
    var ref13 = (item === null || item === void 0 ? void 0 : (ref = item.data) === null || ref === void 0 ? void 0 : ref.programme) || {}, endsAt = ref13.endsAt, startsAt = ref13.startsAt;
    var dateString = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .compareDates */ .aN)(endsAt, dateNow) === -1 ? "Ended on ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .getFullDate */ .xE)(endsAt)) : "".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .compareDates */ .aN)(startsAt, dateNow) === -1 ? "Started" : "Starts", " on ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .getFullDate */ .xE)(startsAt));
    return {
        as: item === null || item === void 0 ? void 0 : (ref1 = item.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.programme) === null || ref2 === void 0 ? void 0 : ref2.relativeLink,
        thumbnail: (item === null || item === void 0 ? void 0 : (ref3 = item.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.programme) === null || ref4 === void 0 ? void 0 : ref4.coverPhotoV1) || (item === null || item === void 0 ? void 0 : (ref5 = item.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.programme) === null || ref6 === void 0 ? void 0 : ref6.coverPhoto),
        colorCode: item === null || item === void 0 ? void 0 : (ref7 = item.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.programme) === null || ref8 === void 0 ? void 0 : ref8.colorCode,
        name: item === null || item === void 0 ? void 0 : (ref9 = item.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.programme) === null || ref10 === void 0 ? void 0 : ref10.name,
        subText: "".concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .pluralize */ ._6)(item === null || item === void 0 ? void 0 : (ref11 = item.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.programme) === null || ref12 === void 0 ? void 0 : ref12.itemCount, "test")).concat(separator).concat(dateString)
    };
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .searchItemTypes.PLUS_LESSON */ .tQ.PLUS_LESSON, function(item) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var author = (item === null || item === void 0 ? void 0 : (ref = item.data) === null || ref === void 0 ? void 0 : (ref1 = ref.lesson) === null || ref1 === void 0 ? void 0 : ref1.author) || (item === null || item === void 0 ? void 0 : (ref2 = item.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.lesson) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.programme) === null || ref4 === void 0 ? void 0 : ref4.author) || {};
    return {
        as: item === null || item === void 0 ? void 0 : (ref5 = item.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.lesson) === null || ref6 === void 0 ? void 0 : ref6.relativeLink,
        thumbnail: (item === null || item === void 0 ? void 0 : (ref7 = item.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.lesson) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.programme) === null || ref9 === void 0 ? void 0 : ref9.coverPhotoV1) || (item === null || item === void 0 ? void 0 : (ref10 = item.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.lesson) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.programme) === null || ref12 === void 0 ? void 0 : ref12.coverPhoto),
        name: item === null || item === void 0 ? void 0 : (ref13 = item.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.lesson) === null || ref14 === void 0 ? void 0 : ref14.name,
        subText: "By ".concat(getAuthorFullName(author))
    };
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .searchItemTypes.USER */ .tQ.USER, function(item) {
    var ref, ref1, ref2;
    return {
        as: item === null || item === void 0 ? void 0 : (ref = item.data) === null || ref === void 0 ? void 0 : ref.relativeLink,
        thumbnail: (item === null || item === void 0 ? void 0 : (ref1 = item.data) === null || ref1 === void 0 ? void 0 : ref1.avatarV1) || (item === null || item === void 0 ? void 0 : (ref2 = item.data) === null || ref2 === void 0 ? void 0 : ref2.avatar),
        name: getAuthorFullName(item === null || item === void 0 ? void 0 : item.data),
        subText: getUserSubText(item)
    };
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .searchItemTypes.TOPOLOGY */ .tQ.TOPOLOGY, function(item) {
    var ref, ref1, ref2, ref3, ref4;
    var coursesCount = ((item === null || item === void 0 ? void 0 : item.data) || {}).coursesCount;
    return {
        as: item === null || item === void 0 ? void 0 : (ref = item.data) === null || ref === void 0 ? void 0 : ref.relativeLink,
        thumbnail: (item === null || item === void 0 ? void 0 : (ref1 = item.data) === null || ref1 === void 0 ? void 0 : ref1.coverPhotoV1) || null,
        name: item === null || item === void 0 ? void 0 : (ref2 = item.data) === null || ref2 === void 0 ? void 0 : ref2.name,
        subText: "".concat((item === null || item === void 0 ? void 0 : (ref3 = item.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.parents) === null || ref4 === void 0 ? void 0 : ref4[0]) || "").concat(coursesCount > 0 ? separator : "").concat(getFormattedCount(coursesCount, "course"))
    };
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .searchItemTypes.BATCH */ .tQ.BATCH, function(item) {
    return {
        as: "/batch/".concat(item === null || item === void 0 ? void 0 : item.data.slug, "/").concat(item === null || item === void 0 ? void 0 : item.data.uid),
        thumbnail: (item === null || item === void 0 ? void 0 : item.data.coverPhotoV1) || null,
        name: item === null || item === void 0 ? void 0 : item.data.name,
        subText: "By ".concat(getAuthorFullName(item === null || item === void 0 ? void 0 : item.data.authors[0]), " & ").concat((item === null || item === void 0 ? void 0 : item.data.authors.length) - 1, " more")
    };
}), _obj);
var searchItemsTypesValues = Object.values(_constants_index__WEBPACK_IMPORTED_MODULE_1__/* .searchItemTypes */ .tQ);
var processRecentSearchesData = function(result) {
    try {
        var ref, ref1;
        return ((result === null || result === void 0 ? void 0 : (ref = result.blocks) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.items) || []).filter(function(item) {
            return searchItemsTypesValues.includes(item === null || item === void 0 ? void 0 : item.type);
        }).map(function(item) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, item), {
                info: itemTypeFormatter[item === null || item === void 0 ? void 0 : item.type](item)
            });
        });
    } catch (e) {
        return [];
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (processRecentSearchesData);


/***/ }),

/***/ 15509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39636);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _icon_ArrowBack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93303);
/* harmony import */ var _icon_Close__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(112);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48821);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2080);








var fontGrey = "var(--color-text-primary)";
var StyledDrawer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
    target: "eqzpp0y0",
    label: "StyledDrawer"
})("&.MuiDrawer-root > .MuiPaper-root{background-color:", function(param) {
    var $backgroundColor = param.$backgroundColor;
    return $backgroundColor || "var(--color-base-0)";
}, ";display:grid;grid-template-columns:repeat(10,", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ");grid-column-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";grid-auto-rows:max-content;padding-left:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_12B */ .t8.SL, ";padding-top:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_6B */ .t8.BY, ";padding-right:115px;overflow-x:hidden;background-image:", function(param) {
    var $imageURL = param.$imageURL;
    return $imageURL && "url(".concat((0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_3__/* .getImage */ .gJ)($imageURL), ")");
}, ";background-position:", function(param) {
    var $imagePosition = param.$imagePosition;
    return $imagePosition;
}, ";background-repeat:no-repeat;background-size:", function(param) {
    var $imageSize = param.$imageSize;
    return $imageSize;
}, ";background-attachment:", function(param) {
    var $backgroundAttachment = param.$backgroundAttachment;
    return $backgroundAttachment;
}, ";", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;padding-left:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";padding-right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";overflow-x:initial;grid-template-columns:repeat(10,1fr);}", function(param) {
    var $login = param.$login, $hideCloseButton = param.$hideCloseButton;
    return !$hideCloseButton && "grid-template-rows: 60px ".concat($login ? "1fr" : "", ";");
}, "}");
var CloseWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "eqzpp0y1",
    label: "CloseWrapper"
})("grid-column:1/11;cursor:pointer;@media (max-width:47.95em){grid-column:1/2;width:24px;height:24px;}");
var Drawer = function(param) {
    var children = param.children, anchor = param.anchor, backgroundColor = param.backgroundColor, drawerState = param.drawerState, onClose = param.onClose, hideCloseButton = param.hideCloseButton, showBackButton = param.showBackButton, elevation = param.elevation, onPressBack = param.onPressBack, imageURL = param.imageURL, imagePosition = param.imagePosition, imageSize = param.imageSize, backgroundAttachment = param.backgroundAttachment, disableBackdropClick = param.disableBackdropClick, disableEscapeKeyDown = param.disableEscapeKeyDown, login = param.login, variant = param.variant, className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(StyledDrawer, {
        anchor: anchor,
        $backgroundColor: backgroundColor,
        open: drawerState,
        onClose: onClose,
        PaperProps: {
            id: "DrawerPaper"
        },
        $imageURL: imageURL,
        $imagePosition: imagePosition,
        $imageSize: imageSize,
        $backgroundAttachment: backgroundAttachment,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disableBackdropClick: disableBackdropClick,
        $login: login,
        $hideCloseButton: hideCloseButton,
        variant: variant,
        className: className,
        elevation: elevation,
        children: [
            !hideCloseButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CloseWrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_icon_Close__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    size: "24px",
                    onClick: onClose,
                    color: fontGrey
                })
            }),
            showBackButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CloseWrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_icon_ArrowBack__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    size: "24px",
                    onClick: onPressBack,
                    color: fontGrey
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Drawer);
Drawer.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOf([
            null
        ]),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node)
    ]),
    backgroundColor: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    anchor: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOf([
        "left",
        "right",
        "top",
        "bottom"
    ]),
    drawerState: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired),
    hideCloseButton: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    showBackButton: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    onPressBack: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    imageURL: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    imagePosition: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    imageSize: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    backgroundAttachment: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    disableEscapeKeyDown: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    disableBackdropClick: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    login: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    elevation: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number)
};
Drawer.defaultProps = {
    children: null,
    backgroundColor: null,
    anchor: "right",
    drawerState: false,
    hideCloseButton: false,
    showBackButton: false,
    onPressBack: null,
    imageURL: null,
    imagePosition: null,
    imageSize: null,
    backgroundAttachment: null,
    elevation: 16,
    disableEscapeKeyDown: false,
    disableBackdropClick: false,
    login: false,
    variant: "temporary",
    className: ""
};


/***/ }),

/***/ 64250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H4 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h4", {
    target: "e1nt2v9v0",
    label: "H4"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.BOLD */ .F3.Pl, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H4 */ .F3.H4, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.HEADER_LINE_HEIGHT */ .F3.rm, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tablet */ .AV.tablet, "){font-size:16px;line-height:100%;}", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H4);
H4.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H4.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 10076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H6 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h6", {
    target: "evqgxxe0",
    label: "H6"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.SEMIBOLD */ .F3.rX, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H6 */ .F3.H6, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.HEADER_LINE_HEIGHT */ .F3.rm, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tablet */ .AV.tablet, "){font-size:12px;}", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H6);
H6.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H6.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 28197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H7 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h6", {
    target: "e1z01og50",
    label: "H7"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.SEMIBOLD */ .F3.rX, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H7 */ .F3.H7, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.HEADER_LINE_HEIGHT */ .F3.rm, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H7);
H7.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H7.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 80867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48821);
/* harmony import */ var _cont_ErrorBoundary_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65103);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18113);
/* harmony import */ var _utils_errorLogger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72874);




/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/jsx-props-no-spreading */ 






/**
 * Extending styles (using @emotion/styled) will only
 * apply the styles to img element, but not to the outer image wrapper (div, next.js adds it) around it.
 *
 * So, can't add styles to the outer image wrapper.
 * Instead, we should create our own wrapper around it and apply styles to it.
 */ var StyledNextImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
    target: "e1pacfim0",
    label: "StyledNextImage"
})("-webkit-user-drag:none;user-select:none;");
var SourceImage = function(_param) {
    var src = _param.src, height = _param.height, width = _param.width, hasError = _param.hasError, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "src",
        "height",
        "width",
        "hasError"
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!hasError) {
            (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .validateImage */ .ap)({
                src: src,
                width: width,
                height: height,
                type: "LEGACY"
            });
        }
    }, [
        hasError,
        height,
        src,
        width
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(StyledNextImage, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        height: height,
        width: width,
        src: src || _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .fillerImageURL */ .cE,
        loader: _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .imageLoader */ .XI
    }));
};
var Image = function(props) {
    return  true && (0,_utils_cookies__WEBPACK_IMPORTED_MODULE_5__/* .readCookie */ .vQ)(_utils_errorLogger__WEBPACK_IMPORTED_MODULE_6__/* .PROD_COOKIE_LOG_KEY */ .m) || "production" === "development" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cont_ErrorBoundary_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        allowRender: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(SourceImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props))
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(SourceImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props));
};
/* harmony default export */ __webpack_exports__["default"] = (Image);


/***/ }),

/***/ 89116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(868);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _icon_QuestionMark__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);


/* eslint-disable react/jsx-props-no-spreading */ 





var Question = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_icon_QuestionMark__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e14anz5u0",
    label: "Question"
})("background-color:var(--color-i-black);border-radius:50%;padding:2px;");
var StyledTooltip = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        classes: {
            popper: props.className,
            tooltip: "tooltip"
        }
    }, props));
}, {
    target: "e14anz5u1",
    label: "StyledTooltip"
})("&.MuiTooltip-popper{pointer-events:initial;}&{.tooltip{background-color:", function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
}, ";max-width:", function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth;
}, ";border-radius:", function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
}, ";padding:", function(param) {
    var padding = param.padding;
    return padding;
}, ";.MuiTooltip-arrow::before{color:", function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
}, ";}@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.mobile */ .AV.mobile, "){max-width:100%;width:100%;border-radius:8px;padding:", function(param) {
    var padding = param.padding;
    return padding;
}, ";margin:0;}}.arrow{color:var(--color-i-black);left:", function(param) {
    var left = param.left;
    return left;
}, ";}.popper{pointer-events:initial;}.tooltipPlacementBottom{margin-top:6px;margin-right:", function(param) {
    var marginRight = param.marginRight;
    return marginRight;
}, ";}}");
var Tooltip = function(param) {
    var children = param.children, arrow = param.arrow, title = param.title, maxWidth = param.maxWidth, marginRight = param.marginRight, backgroundColor = param.backgroundColor, open = param.open, placement = param.placement, borderRadius = param.borderRadius, padding = param.padding, left = param.left, popperProps = param.popperProps, className = param.className, enterDelay = param.enterDelay;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(open), tooltipOpen = ref[0], setTooltipOpen = ref[1];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledTooltip, {
            arrow: arrow,
            open: open !== null && open !== void 0 ? open : tooltipOpen,
            title: title,
            maxWidth: maxWidth,
            marginRight: marginRight,
            backgroundColor: backgroundColor,
            onClose: function() {
                return setTooltipOpen(false);
            },
            onOpen: function() {
                return setTooltipOpen(true);
            },
            placement: placement,
            className: className,
            borderRadius: borderRadius,
            left: left,
            padding: padding,
            PopperProps: popperProps,
            enterDelay: enterDelay,
            children: children || /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Question, {
                    size: "12px",
                    color: "var(--color-i-white)"
                })
            })
        })
    });
};
Tooltip.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node.isRequired),
    arrow: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node.isRequired),
    maxWidth: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    marginRight: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    backgroundColor: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    placement: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    open: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    borderRadius: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    padding: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    left: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    popperProps: prop_types__WEBPACK_IMPORTED_MODULE_7___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_7___default().any)),
    enterDelay: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number)
};
Tooltip.defaultProps = {
    arrow: true,
    maxWidth: "300px",
    marginRight: "0px",
    backgroundColor: "var(--color-i-black)",
    className: "",
    placement: "bottom",
    open: null,
    borderRadius: null,
    padding: null,
    left: null,
    popperProps: {},
    enterDelay: 100
};
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);


/***/ }),

/***/ 49276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _StreakCircularProgressBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28204);




var ProgressContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "egkmjj70",
    label: "ProgressContainer"
})("width:", function(param) {
    var $width = param.$width;
    return $width;
}, "px;height:", function(param) {
    var $height = param.$height;
    return $height;
}, "px;position:relative;");
var StyledCircularProgressBar = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_StreakCircularProgressBar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "egkmjj71",
    label: "StyledCircularProgressBar"
})("position:absolute;left:0;right:0;top:0;bottom:0;margin:auto;");
var StreakCircles = function(param) {
    var dailyWatchMinPercentage = param.dailyWatchMinPercentage, questionsAttemptPercentage = param.questionsAttemptPercentage, outerSqSize = param.outerSqSize, innerSqSize = param.innerSqSize, outerStrokeWidth = param.outerStrokeWidth, innerStrokeWidth = param.innerStrokeWidth, width = param.width, height = param.height;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(ProgressContainer, {
        $width: width,
        $height: height,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledCircularProgressBar, {
                sqSize: outerSqSize,
                percentage: dailyWatchMinPercentage,
                strokeWidth: outerStrokeWidth,
                color: "var(--color-i-blue-streaks)",
                animate: true
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledCircularProgressBar, {
                sqSize: innerSqSize,
                percentage: questionsAttemptPercentage,
                strokeWidth: innerStrokeWidth,
                color: "var(--color-i-orange-streaks)",
                animate: true
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StreakCircles);


/***/ }),

/***/ 28204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




var Circle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("circle", {
    target: "e6832dg0",
    label: "Circle"
})("fill:none;stroke:", function(param) {
    var $color = param.$color;
    return $color;
}, ";stroke-linecap:round;stroke-linejoin:round;transform-origin:50% 50%;transform:", function(param) {
    var $transform = param.$transform;
    return $transform;
}, ";");
var AnimatedCircle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(Circle, {
    target: "e6832dg1",
    label: "AnimatedCircle"
})("transition:stroke-dasharray 500ms ease-out;");
var StreakCircularProgressBar = function(param) {
    var sqSize = param.sqSize, percentage = param.percentage, strokeWidth = param.strokeWidth, color = param.color, outerPercentage = param.outerPercentage, className = param.className, animate = param.animate;
    var boundedPercentage = percentage > 100 ? 100 : percentage;
    var radius = (sqSize - strokeWidth) / 2;
    var viewBox = "0 0 ".concat(sqSize, " ").concat(sqSize);
    var strokeLength = 2 * Math.PI * radius;
    var rotate = 270 + (100 - outerPercentage) * 1.8;
    var transform = "rotateZ(".concat(rotate, "deg)");
    var InnerCircle = animate ? AnimatedCircle : Circle;
    var dashArray = radius * Math.PI * 2;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("svg", {
        width: sqSize,
        height: sqSize,
        viewBox: viewBox,
        className: className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(Circle, {
                cx: sqSize / 2,
                cy: sqSize / 2,
                r: radius,
                strokeWidth: "".concat(strokeWidth, "px"),
                $color: "var(--color-divider)",
                $transform: transform,
                $strokeLength: strokeLength,
                className: "outer"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(InnerCircle, {
                cx: sqSize / 2,
                cy: sqSize / 2,
                r: radius,
                strokeWidth: "".concat(strokeWidth, "px"),
                $color: color,
                $transform: transform,
                $strokeLength: strokeLength,
                className: "inner",
                style: {
                    strokeDasharray: dashArray,
                    strokeDashoffset: dashArray - dashArray * boundedPercentage / 100
                }
            })
        ]
    });
};
StreakCircularProgressBar.propTypes = {
    sqSize: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    percentage: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    strokeWidth: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    outerPercentage: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    animate: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool)
};
StreakCircularProgressBar.defaultProps = {
    sqSize: 200,
    percentage: 25,
    strokeWidth: 10,
    color: "",
    outerPercentage: 100,
    className: "",
    animate: false
};
/* harmony default export */ __webpack_exports__["Z"] = (StreakCircularProgressBar);


/***/ }),

/***/ 73993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D4": function() { return /* binding */ getIsPartnerEducatorBatch; },
/* harmony export */   "DJ": function() { return /* binding */ getOfferEndMessage; },
/* harmony export */   "Eg": function() { return /* binding */ getBatchType; },
/* harmony export */   "Ej": function() { return /* binding */ DEFAULT_SUBJECT_VALUE; },
/* harmony export */   "Ic": function() { return /* binding */ getBatchReferralInStorage; },
/* harmony export */   "Lk": function() { return /* binding */ SESSION_TYPE_MAP; },
/* harmony export */   "MB": function() { return /* binding */ EDUCATOR_TYPES; },
/* harmony export */   "Rf": function() { return /* binding */ FETCH_STORE_SYLLABUS_VALUES; },
/* harmony export */   "Sf": function() { return /* binding */ getIsStoreSyllabus; },
/* harmony export */   "Tv": function() { return /* binding */ BATCH_CONTENT_TYPE_MAP; },
/* harmony export */   "ax": function() { return /* binding */ getEnrollmentEndMessage; },
/* harmony export */   "bL": function() { return /* binding */ getIsStoreModule; },
/* harmony export */   "gx": function() { return /* binding */ getHasStorePurchase; },
/* harmony export */   "ko": function() { return /* binding */ getAccessEndDate; },
/* harmony export */   "nQ": function() { return /* binding */ getIsStorePath; },
/* harmony export */   "oc": function() { return /* binding */ LESSON_ITEMS_ON_BATCH_PAGE; },
/* harmony export */   "tn": function() { return /* binding */ getSkuBasedEventProps; },
/* harmony export */   "v7": function() { return /* binding */ BATCH_CONTENT_TYPE_ID; },
/* harmony export */   "z_": function() { return /* binding */ setBatchReferralInStorage; },
/* harmony export */   "zm": function() { return /* binding */ getActiveSku; }
/* harmony export */ });
/* unused harmony exports BATCH_TYPE, removeStoreBatchInStorage */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97428);
/* harmony import */ var _utils_getItemFromSessionStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97903);
/* harmony import */ var _utils_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29626);






var BATCH_CONTENT_TYPE_ID = 500;
var BATCH_TYPE = {
    MODULE: "Module",
    PLAYLIST: "Playlist"
};
var BATCH_CONTENT_TYPE_MAP = {
    LIVE: "Live",
    RECORDED: "Recorded",
    LIVE_RECORDED: "Live + Recorded",
    HYBRID: "HYBRID",
    CENTER: "Center",
    OFFLINE: "Offline"
};
var STORE_BATCH_KEY = "storeBatchReferralCodes";
var SESSION_TYPE_MAP = {
    ALL: "1",
    CLASSES: "2",
    TESTS: "3"
};
var LESSON_ITEMS_ON_BATCH_PAGE = {
    START: 0,
    END: 3
};
var DEFAULT_SUBJECT_VALUE = "ALL";
var EDUCATOR_TYPES = {
    PLUS: 1,
    PARTNER: 2
};
var FETCH_STORE_SYLLABUS_VALUES = {
    LIMIT: 10,
    OFFSET: 0
};
var getIsStorePath = function(route) {
    return route.indexOf("store/batch/") >= 0;
};
var getActiveSku = function(purchaseInfo) {
    var skus = purchaseInfo === null || purchaseInfo === void 0 ? void 0 : purchaseInfo.skus;
    return skus === null || skus === void 0 ? void 0 : skus[0];
};
var getIsPartnerEducatorBatch = function(batchDetails) {
    return (batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.educatorType) === EDUCATOR_TYPES.PARTNER;
};
var getIsStoreSyllabus = function(param) {
    var additionalFeatures = param.additionalFeatures;
    return additionalFeatures ? (additionalFeatures === null || additionalFeatures === void 0 ? void 0 : additionalFeatures.indexOf(BATCH_TYPE.PLAYLIST)) !== -1 : false;
};
var getIsStoreModule = function(param) {
    var additionalFeatures = param.additionalFeatures;
    return additionalFeatures ? (additionalFeatures === null || additionalFeatures === void 0 ? void 0 : additionalFeatures.indexOf(BATCH_TYPE.MODULE)) !== -1 : false;
};
var getHasStorePurchase = function(batchUID, purchaseInfo) {
    var ref;
    var purchases = purchaseInfo === null || purchaseInfo === void 0 ? void 0 : (ref = purchaseInfo.metaInfo) === null || ref === void 0 ? void 0 : ref.latestUserSkusTypeWise;
    if (purchases && purchases[BATCH_CONTENT_TYPE_ID]) {
        var batchPurchases = purchases[BATCH_CONTENT_TYPE_ID];
        var currentBatchActivePurchase = batchPurchases.find(function(purchase) {
            return purchase.objectUid === batchUID;
        });
        return !!(currentBatchActivePurchase && !(0,_utils_isEmpty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(currentBatchActivePurchase));
    }
    return false;
};
var getEnrollmentEndMessage = function(date) {
    if (!date) return "";
    var relativeDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRelativeDayOrCurrentDateWithTDays */ .Aw)(date, true, 7, true);
    var isRelativeDateTodayTomorrow = _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .todayTomorrowConfig.some */ .Wb.some(function(day) {
        return day === relativeDate;
    });
    if (!relativeDate) {
        return "";
    }
    if (isRelativeDateTodayTomorrow) {
        return "Enrolment ends ".concat(relativeDate);
    }
    if (relativeDate <= 7 && relativeDate > 0) {
        return "Enrolment ends in ".concat(relativeDate, " days");
    }
    return "Enrolment ends on ".concat(relativeDate);
};
var getOfferEndMessage = function(date) {
    if (!date) return "";
    var relativeDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRelativeDayOrCurrentDateWithTDays */ .Aw)(date, true, 7, true);
    var isRelativeDateTodayTomorrow = _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .todayTomorrowConfig.some */ .Wb.some(function(day) {
        return day === relativeDate;
    });
    if (!relativeDate) {
        return "";
    }
    if (isRelativeDateTodayTomorrow) {
        return "Offer ends ".concat(relativeDate);
    }
    if (relativeDate <= 7 && relativeDate > 0) {
        return "Offer ends in ".concat(relativeDate, " days");
    }
    return "Offer ends on ".concat(relativeDate);
};
var getAccessEndDate = function(purchaseInfo, batchUID, isStoreRoute, isSubscribed) {
    var ref;
    var activeSku = getActiveSku(purchaseInfo);
    if (activeSku && !(0,_utils_isEmpty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(activeSku) && isStoreRoute && !isSubscribed) {
        return (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRegularDate */ .Wg)(activeSku === null || activeSku === void 0 ? void 0 : activeSku.accessEndDate);
    }
    var purchases = purchaseInfo === null || purchaseInfo === void 0 ? void 0 : (ref = purchaseInfo.metaInfo) === null || ref === void 0 ? void 0 : ref.latestUserSkusTypeWise;
    if (purchases && purchases[BATCH_CONTENT_TYPE_ID]) {
        var batchPurchases = purchases[BATCH_CONTENT_TYPE_ID];
        var currentBatchActivePurchase = batchPurchases.find(function(purchase) {
            return purchase.objectUid === batchUID;
        });
        return currentBatchActivePurchase && (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRegularDate */ .Wg)(currentBatchActivePurchase.expiredAt);
    }
};
var getBatchType = function(contentType) {
    if (contentType === BATCH_CONTENT_TYPE_MAP.LIVE_RECORDED || contentType === BATCH_CONTENT_TYPE_MAP.RECORDED) {
        return "Recorded";
    }
    return contentType;
};
var getSkuBasedEventProps = function(activeSku, batchDetails) {
    return {
        entity_content_type: "Batch",
        entity_title: batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.name,
        entity_uid: batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.uid,
        last_primary_source: "Store",
        subscription_type: "Store Subscription",
        offer_price: activeSku === null || activeSku === void 0 ? void 0 : activeSku.price,
        offer_end_date: (activeSku === null || activeSku === void 0 ? void 0 : activeSku.priceEffectiveTill) || undefined,
        subscription_price: (activeSku === null || activeSku === void 0 ? void 0 : activeSku.maxRetailPrice) || (activeSku === null || activeSku === void 0 ? void 0 : activeSku.price),
        subscription_duration: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getDateDifference */ .hM)(activeSku === null || activeSku === void 0 ? void 0 : activeSku.accessEndDate),
        entity_content_subtype: getBatchType(batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.contentType),
        educator_type: (batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.educatorType) === EDUCATOR_TYPES.PARTNER ? "Partner" : "Plus"
    };
};
var getBatchReferralInStorage = function(batchUID) {
    try {
        var referralCodesStr = (0,_utils_getItemFromSessionStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(STORE_BATCH_KEY);
        var referralCodes = !!referralCodesStr && JSON.parse(referralCodesStr);
        return referralCodes && referralCodes[batchUID];
    } catch (e) {
        return null;
    }
};
var setBatchReferralInStorage = function(batchUID, code) {
    try {
        var referralCodesStr = (0,_utils_getItemFromSessionStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(STORE_BATCH_KEY);
        var referralCodes = !!referralCodesStr && JSON.parse(referralCodesStr);
        sessionStorage.setItem(STORE_BATCH_KEY, JSON.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, referralCodes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, batchUID, code))));
    } catch (e) {
        return null;
    }
};
var removeStoreBatchInStorage = function() {
    sessionStorage.removeItem(STORE_BATCH_KEY);
};



/***/ }),

/***/ 34085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var _base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28066);
/* harmony import */ var _base_Drawer_Drawer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15509);
/* harmony import */ var _stores_selectors_login__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98964);
/* harmony import */ var _stores_login_loginStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44545);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87936);
/* harmony import */ var _hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52405);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43605);




/* eslint-disable react/jsx-props-no-spreading */ 






var Login = (0,_base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(35303), __webpack_require__.e(82492), __webpack_require__.e(52420), __webpack_require__.e(96523), __webpack_require__.e(9720), __webpack_require__.e(46571), __webpack_require__.e(94336), __webpack_require__.e(84079), __webpack_require__.e(98789)]).then(__webpack_require__.bind(__webpack_require__, 84079));
});
var LoginDialogBox = (0,_base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
    return __webpack_require__.e(/* import() */ 13088).then(__webpack_require__.bind(__webpack_require__, 13088));
});
var LoginComponent = function(param) {
    var _loginProps = param.loginProps, loginProps = _loginProps === void 0 ? {} : _loginProps, _drawerProps = param.drawerProps, drawerProps = _drawerProps === void 0 ? {} : _drawerProps;
    var IsNewLoginModal = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_6__/* .getIsNewLoginModal */ .zf);
    var goalSegmentData = (0,_hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({});
    var onClose = drawerProps.onClose, drawerState = drawerProps.drawerState, restDrawerProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(drawerProps, [
        "onClose",
        "drawerState"
    ]);
    var handleClose = function() {
        _actions_analytics__WEBPACK_IMPORTED_MODULE_3__/* .segment.track */ .EX.track(_constants__WEBPACK_IMPORTED_MODULE_5__/* .LOGIN_SIDE_CURTAIN_DISMISSED */ .z0, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, goalSegmentData));
        onClose();
    };
    if (!drawerState) return null;
    if (IsNewLoginModal) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(LoginDialogBox, {
        isOpen: drawerState,
        onClose: onClose,
        loginProps: loginProps
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_base_Drawer_Drawer__WEBPACK_IMPORTED_MODULE_1__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        login: true,
        drawerState: drawerState,
        onClose: handleClose
    }, restDrawerProps), {
        children: drawerState && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Login, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, loginProps))
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginComponent);


/***/ }),

/***/ 80560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_abHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76226);
/* harmony import */ var _api_fetchers_experiments__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97163);
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18113);
/* harmony import */ var _utils_session_validateAndSetSessionId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32415);
/* harmony import */ var _cont_Login_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43605);
/* harmony import */ var _stores_selectors_login__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98964);
/* harmony import */ var _stores_login_loginStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44545);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);









// Test1 - with phone number and OTP field on the same page
// Test2 - phone number on one page and OTP on other page
// Control - side curtain
var useLoginModalExperiment = function() {
    var setIsNewLoginModal = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_8__/* .getSetIsNewLoginModal */ .qN);
    var setIsLoginModalExperiment = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_8__/* .getSetIsLoginModalExperiment */ .lf);
    var setIsLoginModalVariation = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_8__/* .getSetIsLoginModalVariation */ .Rw);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var route = router.route;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (_cont_Login_constants__WEBPACK_IMPORTED_MODULE_5__/* .routesToBeInCluded.includes */ .tP.includes(route)) {
            (0,_utils_session_validateAndSetSessionId__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)();
            var deviceID = _utils_cookies__WEBPACK_IMPORTED_MODULE_3__/* ["default"].readCookie */ .ZP.readCookie(_utils_session_validateAndSetSessionId__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_ID_COOKIE_NAME */ .CR);
            (0,_api_fetchers_experiments__WEBPACK_IMPORTED_MODULE_2__/* .fetchABExperimentData */ .d)(_cont_Login_constants__WEBPACK_IMPORTED_MODULE_5__/* .LOGIN_MODAL_EXPERIMENT */ .OC, _utils_abHelper__WEBPACK_IMPORTED_MODULE_1__/* .abProxyJWT */ .q_, deviceID).then(function(res) {
                if (res === null || res === void 0 ? void 0 : res.variation) {
                    setIsNewLoginModal(res.variation !== _utils_abHelper__WEBPACK_IMPORTED_MODULE_1__/* .abVariations.CONTROL */ .WS.CONTROL);
                    setIsLoginModalExperiment(res.variation !== _utils_abHelper__WEBPACK_IMPORTED_MODULE_1__/* .abVariations.CONTROL */ .WS.CONTROL);
                    setIsLoginModalVariation(res.variation);
                } else {
                    setIsNewLoginModal(false);
                    setIsLoginModalExperiment(false);
                    setIsLoginModalVariation(_utils_abHelper__WEBPACK_IMPORTED_MODULE_1__/* .abVariations.CONTROL */ .WS.CONTROL);
                }
            });
        } else {
            setIsNewLoginModal(false);
            setIsLoginModalExperiment(false);
            setIsLoginModalVariation(_utils_abHelper__WEBPACK_IMPORTED_MODULE_1__/* .abVariations.CONTROL */ .WS.CONTROL);
        }
    }, [
        route,
        setIsNewLoginModal,
        setIsLoginModalExperiment,
        setIsLoginModalVariation
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLoginModalExperiment);


/***/ }),

/***/ 78280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _comp_Streaks_StreakCircles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49276);
/* harmony import */ var _icon_Check__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92542);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80867);
/* harmony import */ var _comp_Streaks_StreakCircularProgressBar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28204);







var progressCompleteImageSrc = "layout/header/progress_complete.svg";
var progressCompleteV2ImageSrc = "layout/header/progress_complete_v2.svg";
var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "efchofb0",
    label: "Wrapper"
})("position:relative;");
var StyCheck = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_icon_Check__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "efchofb1",
    label: "StyCheck"
})("position:absolute;top:", function(param) {
    var $position = param.$position;
    return $position;
}, "px;left:", function(param) {
    var $position = param.$position;
    return $position;
}, "px;");
var StreakItemV2 = function(param) {
    var isStreaksNewFlow = param.isStreaksNewFlow, dailyWatchMinPercentage = param.dailyWatchMinPercentage, questionsAttemptPercentage = param.questionsAttemptPercentage, strokeWidth = param.strokeWidth, outerSqSize = param.outerSqSize, innerSqSize = param.innerSqSize, isCompleted = param.isCompleted, size = param.size;
    if (isCompleted) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_base_Image__WEBPACK_IMPORTED_MODULE_4__["default"], {
        src: isStreaksNewFlow ? progressCompleteV2ImageSrc : progressCompleteImageSrc,
        alt: "check rounded",
        width: size,
        height: size
    });
    if (isStreaksNewFlow) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_comp_Streaks_StreakCircles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    height: size,
                    width: size,
                    outerSqSize: outerSqSize,
                    innerSqSize: innerSqSize,
                    outerStrokeWidth: strokeWidth,
                    innerStrokeWidth: strokeWidth,
                    dailyWatchMinPercentage: dailyWatchMinPercentage,
                    questionsAttemptPercentage: questionsAttemptPercentage
                }),
                isCompleted && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyCheck, {
                    size: size / 2,
                    color: "var(--color-i-blue-streaks)",
                    $position: size / 4
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_comp_Streaks_StreakCircularProgressBar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        sqSize: outerSqSize,
        percentage: dailyWatchMinPercentage,
        strokeWidth: strokeWidth,
        color: "var(--color-i-blue)",
        outerPercentage: 95
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StreakItemV2);


/***/ }),

/***/ 84566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K1": function() { return /* binding */ HEADER_TABS; },
/* harmony export */   "K7": function() { return /* binding */ OFFLINE_CENTER_ICONS; },
/* harmony export */   "NK": function() { return /* binding */ SUBSCRIPTION; },
/* harmony export */   "NW": function() { return /* binding */ TABSID; },
/* harmony export */   "TJ": function() { return /* binding */ OFFLINE_CENTER_CTA; },
/* harmony export */   "Tl": function() { return /* binding */ SUCCESS_STORY; },
/* harmony export */   "Y7": function() { return /* binding */ STORE_TAB; },
/* harmony export */   "Yz": function() { return /* binding */ ABOUT_EXAM_SEC; },
/* harmony export */   "ch": function() { return /* binding */ ABOUT_TAB; },
/* harmony export */   "d6": function() { return /* binding */ GOAL_HOME; },
/* harmony export */   "g": function() { return /* binding */ BATCHES_SEC; },
/* harmony export */   "js": function() { return /* binding */ learnerDefaultProps; },
/* harmony export */   "rM": function() { return /* binding */ plusSubscriptionTiles; },
/* harmony export */   "rn": function() { return /* binding */ DEFAULT_STORE_TAB; },
/* harmony export */   "t6": function() { return /* binding */ educatorDefaultProps; },
/* harmony export */   "ud": function() { return /* binding */ STORE; },
/* harmony export */   "uv": function() { return /* binding */ EDUCATORS_SEC; },
/* harmony export */   "v4": function() { return /* binding */ GET_STARTED; }
/* harmony export */ });
/* unused harmony exports STORE_MAP, EDUCATORS, BATCH, SUBSCRIPTION_PLANS, SUCCESS_STORIES, ABOUT_EXAM, NEW_GOAL_PAGE_EXP */
// page 1 block id
var GET_STARTED = "getStarted";
var EDUCATORS_SEC = "educatorsSection";
var BATCHES_SEC = "batchesSection";
var ABOUT_EXAM_SEC = "aboutExamSection";
var STORE = "store";
// page name
var GOAL_HOME = "Goal home";
var SUBSCRIPTION = "Goal subscription";
var SUCCESS_STORY = "success story";
var STORE_MAP = "store";
//
var EDUCATORS = "educators";
var BATCH = "batch";
var SUBSCRIPTION_PLANS = "subscription plans";
var SUCCESS_STORIES = "success stories";
var ABOUT_EXAM = "about exam";
var TABSID = {
    GET_STARTED: "tab_get_started",
    EDUCATORS_SEC: "tab_educators",
    BATCHES_SEC: "tab_batch",
    SUBSCRIPTION_PLANS: "tab_subscription_plans",
    SUCCESS_STORIES: "tab_success_stories",
    ABOUT_EXAM: "tab_about_exam",
    STORE: "tab_store"
};
var ABOUT_TAB = {
    id: "tab_about_exam",
    label: "About exam",
    sectionName: "about exam",
    sectionId: ABOUT_EXAM_SEC,
    hash: "about-exam",
    page: "" // for new page tab
};
var STORE_TAB = {
    id: "tab_store",
    label: "Store",
    sectionName: "store",
    sectionId: "",
    hash: "",
    page: "store"
};
var HEADER_TABS = [
    {
        id: "tab_get_started",
        label: "Get started",
        sectionName: "getStarted",
        sectionId: GET_STARTED,
        hash: "",
        page: "Goal home"
    },
    {
        id: "tab_educators",
        label: "Educators",
        sectionId: EDUCATORS_SEC,
        sectionName: "educators",
        hash: "educators",
        page: ""
    },
    {
        id: "tab_batch",
        label: "Batch",
        sectionId: BATCHES_SEC,
        sectionName: "batch",
        hash: "batches",
        page: ""
    },
    {
        id: "tab_subscription_plans",
        label: "Subscription plan",
        sectionId: "",
        sectionName: "subscription plans",
        hash: "",
        page: "Goal subscription"
    },
    {
        id: "tab_success_stories",
        label: "Success stories",
        sectionId: "",
        sectionName: "success stories",
        hash: "",
        page: "success story"
    }
];
// Install banner deafult props
var educatorDefaultProps = {
    title: "All in one place",
    description: "Schedule your classes, engage with learners, see your performance across your courses",
    androidApp: "https://play.google.com/store/apps/details?id=com.unacademy&referrer=utm_source%3DFooter%26utm_medium%3DWebApp%26utm_campaign%3DFooter%26",
    iosApp: "https://apps.apple.com/in/app/unacademy-educator-app/id1156375099%26referrer%3Dutm_source%253DFooter%2526utm_medium%253DWebApp%2526utm_campaign%253DFooter%2526"
};
var learnerDefaultProps = {
    title: "Online preparation like never before",
    description: [
        "Interactive live classes",
        "Mock tests and practice questions",
        "High-quality notes",
        "Doubt solving"
    ],
    androidApp: "https://play.google.com/store/apps/details?id=com.unacademyapp&referrer=utm_source%3DFooter%26utm_medium%3DWebApp%26utm_campaign%3DFooter%26",
    iosApp: "https://apps.apple.com/in/app/unacademy-learning-app/id1342565069?referrer%3Dutm_source%253DFooter%2526utm_medium%253DWebApp%2526utm_campaign%253DFooter%2526"
};
// exp name
var NEW_GOAL_PAGE_EXP = "web_landing_page_redesign";
// Default Store Tab Experiment key
var DEFAULT_STORE_TAB = "default_store_tab";
// offline center icons file maping
var OFFLINE_CENTER_ICONS = {
    indore: "/offlineCentres/indore_V1.svg",
    kota: "/offlineCentres/kota.svg",
    lucknow: "/offlineCentres/lucknow.svg",
    noida: "/offlineCentres/noida.svg",
    patna: "/offlineCentres/patna.svg",
    ahmedabad: "/offlineCentres/ahmedabad.svg",
    bangalore: "/offlineCentres/bangalore.svg",
    delhi: "/offlineCentres/delhi.svg",
    chandigarh: "/offlineCentres/chandigarh.svg",
    jaipur: "/offlineCentres/jaipur.svg",
    pune: "/offlineCentres/pune.svg",
    vijayawada: "/offlineCentres/vijayawada.svg",
    morecities: "/offlineCentres/morecities.svg",
    viewAll: "/offlineCentres/viewAll.svg"
};
// offline cenetr CTA url
var OFFLINE_CENTER_CTA = {
    TMUVD: "/goal/kota-neet-coaching/TMUVD/centre/Kota-Centre/NXG6I0UBPB",
    YOTUH: "/goal/kota-neet-coaching/YOTUH/centre/Kota-Centre/NXG6I0UBPB" // pragma: allowlist secret
};
// tiles content for sbscription page when only one subscription is avaialble
var plusSubscriptionTiles = [
    {
        subLabel: "Learn with the best educators for online IIT JEE preparation",
        label: "India's top educators"
    },
    {
        subLabel: "Follow all your classes, practice & mock tests on a single unified planner",
        label: "Fully organized planner"
    },
    {
        subLabel: "Live classes, practice questions, mock tests, doubt solving and much more",
        label: "Best-in-class learning experience"
    },
    {
        subLabel: "10000+ questions in the question-bank with detailed soultions, report and insights",
        label: "Tests and unlimited practice"
    }
];


/***/ }),

/***/ 57394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ SINGLE_SELECT; },
/* harmony export */   "Pd": function() { return /* binding */ STORE_FIND_CENTRE_CLICKED; },
/* harmony export */   "QN": function() { return /* binding */ ALL; },
/* harmony export */   "oi": function() { return /* binding */ TAB_STORE_CLICKED; },
/* harmony export */   "q_": function() { return /* binding */ storeSubscriptionTypes; },
/* harmony export */   "qj": function() { return /* binding */ STORE_TAB_FILTER_APPLIED; },
/* harmony export */   "rp": function() { return /* binding */ storeSubscriptionTypesLabel; }
/* harmony export */ });
var TAB_STORE_CLICKED = "Tab - Store Clicked";
var STORE_TAB_FILTER_APPLIED = "Store - Tab Filter Applied";
var STORE_FIND_CENTRE_CLICKED = "Store - Find Centre Clicked";
var storeSubscriptionTypes = {
    BATCH: 500,
    TEST_SERIES: 501
};
var storeSubscriptionTypesLabel = {
    500: "Batch",
    501: "Test Series"
};
var SINGLE_SELECT = "single_select";
var ALL = "All";


/***/ }),

/***/ 93303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var ArrowBack = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M66.9 37.5h-47.267l15.7-15.833c0.452-0.452 0.731-1.077 0.731-1.767s-0.279-1.314-0.731-1.767v0c-0.452-0.452-1.077-0.731-1.767-0.731s-1.314 0.279-1.767 0.731v0l-20 20.2c-0.433 0.424-0.702 1.015-0.702 1.668 0 0.035 0.001 0.069 0.002 0.103l-0-0.005c0.001 0.69 0.281 1.315 0.733 1.767v0l20.2 20c0.442 0.453 1.059 0.733 1.741 0.733 0.009 0 0.018-0 0.027-0h-0.001c1.365-0.020 2.465-1.131 2.465-2.5 0-0.69-0.279-1.315-0.731-1.767v0l-16-15.833h47.367c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5v0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowBack);


/***/ }),

/***/ 70376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);






var Call = function(_param) /*#__PURE__*/ {
    var color = _param.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "color"
    ]);
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        color: color
    }, rest), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.53591 9.40179C5.65841 8.52429 4.99691 7.54179 4.55741 6.54504C4.46441 6.33429 4.51916 6.08754 4.68191 5.92479L5.29616 5.31054C5.79941 4.80729 5.79941 4.09554 5.35991 3.65604L4.47941 2.77629C3.89366 2.19054 2.94416 2.19054 2.35841 2.77629L1.86941 3.26454C1.31366 3.82029 1.08191 4.62204 1.23191 5.41704C1.60241 7.37679 2.74091 9.52254 4.57766 11.3593C6.41441 13.196 8.56016 14.3345 10.5199 14.705C11.3149 14.855 12.1167 14.6233 12.6724 14.0675L13.1607 13.5793C13.7464 12.9935 13.7464 12.044 13.1607 11.4583L12.2809 10.5785C11.8414 10.139 11.1289 10.139 10.6902 10.5785L10.0129 11.2565C9.85016 11.4193 9.60341 11.474 9.39266 11.381C8.39591 10.9408 7.41341 10.2785 6.53591 9.40179Z",
                stroke: color,
                strokeWidth: "1.125",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
                d: "M8.68994 2.87753V1.12253",
                stroke: color,
                strokeWidth: "1.125",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
                d: "M11.8174 4.11501L13.0549 2.88501",
                stroke: color,
                strokeWidth: "1.125",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
                d: "M13.0625 7.25006H14.81",
                stroke: color,
                strokeWidth: "1.125",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Call);
Call.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired)
};


/***/ }),

/***/ 92542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Check = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M32.767 56.1c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-12.767-12.767c-0.416-0.445-0.671-1.045-0.671-1.704 0-1.381 1.119-2.5 2.5-2.5 0.659 0 1.259 0.255 1.706 0.672l-0.001-0.001 11 10.933 25.467-25.433c0.449-0.46 1.074-0.745 1.767-0.745s1.318 0.285 1.766 0.745l0 0.001c0.452 0.452 0.731 1.077 0.731 1.767s-0.279 1.314-0.731 1.767v0l-27.233 27.2c-0.434 0.49-1.064 0.798-1.766 0.8h-0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);


/***/ }),

/***/ 22818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var CheckCircle = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M40 7.5c-17.949 0-32.5 14.551-32.5 32.5s14.551 32.5 32.5 32.5c17.949 0 32.5-14.551 32.5-32.5v0c-0.019-17.942-14.558-32.481-32.498-32.5h-0.002zM56.667 31.567l-20.333 20.4c-0.452 0.453-1.077 0.733-1.767 0.733h-0c-0.689-0.008-1.311-0.287-1.767-0.734l0 0-9.467-9.567c-0.452-0.452-0.731-1.077-0.731-1.767s0.279-1.314 0.731-1.767v0c0.449-0.46 1.074-0.745 1.767-0.745s1.318 0.285 1.766 0.745l0 0.001 7.7 7.8 18.767-18.633c0.449-0.46 1.074-0.745 1.767-0.745s1.318 0.285 1.766 0.745l0 0.001c0.395 0.44 0.637 1.025 0.637 1.667 0 0.741-0.322 1.407-0.834 1.864l-0.002 0.002z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckCircle);


/***/ }),

/***/ 112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Close = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M43.533 40l21.567-21.567c0.416-0.445 0.671-1.045 0.671-1.704 0-1.381-1.119-2.5-2.5-2.5-0.659 0-1.259 0.255-1.706 0.672l0.001-0.001-21.567 21.567-21.567-21.567c-0.445-0.416-1.045-0.671-1.704-0.671-1.381 0-2.5 1.119-2.5 2.5 0 0.659 0.255 1.259 0.672 1.706l-0.001-0.001 21.567 21.567-21.567 21.567c-0.452 0.452-0.731 1.077-0.731 1.767s0.279 1.314 0.731 1.767v0c0.452 0.452 1.077 0.731 1.767 0.731s1.314-0.279 1.767-0.731v0l21.567-21.567 21.567 21.567c0.452 0.452 1.077 0.731 1.767 0.731s1.314-0.279 1.767-0.731v0c0.452-0.452 0.731-1.077 0.731-1.767s-0.279-1.314-0.731-1.767v0z"
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Close);


/***/ }),

/***/ 65734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var QuestionMark = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        viewBox: "0 0 10 16",
        path: "M4.76676 3.2C4.1233 3.2 3.55893 3.51875 3.25467 4.00117C2.77227 4.76606 1.70516 5.02744 0.871227 4.58498C0.0372934 4.1425 -0.247674 3.16373 0.234726 2.39883C1.13695 0.968288 2.82755 0 4.76676 0C7.65708 0 10 2.14904 10 4.8C10 6.88995 8.54376 8.668 6.51117 9.32688V9.6C6.51117 10.4837 5.7302 11.2 4.76676 11.2C3.80338 11.2 3.02237 10.4837 3.02237 9.6V8C3.02237 7.11635 3.80338 6.4 4.76676 6.4C5.7302 6.4 6.51117 5.68365 6.51117 4.8C6.51117 3.91635 5.7302 3.2 4.76676 3.2ZM4.76676 16C5.7302 16 6.51117 15.2837 6.51117 14.4C6.51117 13.5163 5.7302 12.8 4.76676 12.8C3.80336 12.8 3.02235 13.5163 3.02235 14.4C3.02235 15.2837 3.80336 16 4.76676 16Z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuestionMark);


/***/ }),

/***/ 96814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Skeletons_RoundedRectSkeleton; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
;// CONCATENATED MODULE: ./src/components/Skeletons/SkeletonGradient.jsx

var SkeletonGradient = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ejfdz080",
    label: "SkeletonGradient"
})("background:linear-gradient(\n    90deg,var(--color-divider) -4.32%,var(--color-base-0) 100%\n  );");
/* harmony default export */ var Skeletons_SkeletonGradient = (SkeletonGradient);

;// CONCATENATED MODULE: ./src/components/Skeletons/RoundedRectSkeleton.jsx


var RoundedRectSkeleton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Skeletons_SkeletonGradient, {
    target: "e10huhza0",
    label: "RoundedRectSkeleton"
})("border-radius:", function(param) {
    var height = param.height;
    return height / 2;
}, "px;width:", function(param) {
    var width = param.width;
    return width;
}, "px;height:", function(param) {
    var height = param.height;
    return height;
}, "px;");
/* harmony default export */ var Skeletons_RoundedRectSkeleton = (RoundedRectSkeleton);


/***/ }),

/***/ 88268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JL": function() { return /* binding */ ScheduleItemTypeLabel; },
/* harmony export */   "Tc": function() { return /* binding */ scheduleItemStatus; },
/* harmony export */   "ft": function() { return /* binding */ ScheduleItemStatusLabel; },
/* harmony export */   "hc": function() { return /* binding */ scheduleItemTypes; },
/* harmony export */   "pt": function() { return /* binding */ plannerEventTypes; }
/* harmony export */ });
/* unused harmony export ScheduleItemRankLabel */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43135);


var scheduleItemStatus = {
    MISSED: 1,
    WATCHED_OR_ATTEMPTED: 2,
    UPCOMING: 3,
    CANCELLED: 4
};
var _obj;
var ScheduleItemStatusLabel = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.MISSED, "missed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.WATCHED_OR_ATTEMPTED, "completed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.UPCOMING, "upcoming"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, scheduleItemStatus.CANCELLED, "cancelled"), _obj);
var scheduleItemTypes = {
    CLASS: 1,
    QUIZ: 2,
    COMBAT: 3,
    TEST: 4,
    LIVE_INTERACTION: 5,
    OPENHOUSE: 6,
    DAILY_PRACTICE_REMINDER: 7
};
var _obj1;
var ScheduleItemTypeLabel = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.CLASS, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.CLASS */ .cs.CLASS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.QUIZ, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.QUIZ */ .cs.QUIZ), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.TEST, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.TEST */ .cs.TEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, scheduleItemTypes.COMBAT, _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .itemTypes.COMBAT */ .cs.COMBAT), _obj1);
var _obj2;
var ScheduleItemRankLabel = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.CLASS, "Lesson"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.QUIZ, "Quiz"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.COMBAT, "Combat"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.TEST, "Test"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.LIVE_INTERACTION, "Live Interaction"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, scheduleItemTypes.OPENHOUSE, "Openhouse"), _obj2);
// categorized based on their height
var plannerEventTypes = {
    CLASS: "class",
    CLASS_WITH_PRACTICE: "class_with_practice",
    TEST: "test",
    TEST_WITH_EDUCATOR: "test_with_educator",
    QUIZ: "quiz",
    COMBAT: "combat",
    LIVE_INTERACTION: "live_interaction",
    DAILY_PRACTICE_REMINDER: "daily_practice_reminder",
    OPENHOUSE: "openhouse",
    OFFLINE_TEST: "offline_test"
};


/***/ }),

/***/ 6858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/exhaustive-deps */ 
var useFirstRenderSkip = function(callback, deps) {
    var isFirstRenderingDone = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isFirstRenderingDone.current) callback();
        else isFirstRenderingDone.current = true;
    }, deps);
};
/* harmony default export */ __webpack_exports__["Z"] = (useFirstRenderSkip);


/***/ }),

/***/ 40101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);

var HeaderContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("header", {
    target: "esrd3a60",
    label: "HeaderContainer"
})("height:72px;width:100%;position:sticky;top:0;z-index:3;");
/* harmony default export */ __webpack_exports__["Z"] = (HeaderContainer);


/***/ }),

/***/ 47731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);


var HeaderParent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "euhzmok0",
    label: "HeaderParent"
})("width:1136px;margin:auto;height:100%;position:relative;display:flex;align-items:center;", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{width:728px;}");
/* harmony default export */ __webpack_exports__["Z"] = (HeaderParent);


/***/ }),

/***/ 56608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);
/* harmony import */ var _layout_Footer_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1870);
/* harmony import */ var aquilla_core_organisms_FooterLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(347);
/* harmony import */ var _events_segmentStorage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71250);
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59375);
/* harmony import */ var _constants_support__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49519);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80867);
/* harmony import */ var aquilla_styled_StyleProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12848);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84181);

/* eslint-disable react/jsx-key */ 










// import useCentreInfo from '@api/hooks/citySpecificOfflineCentres/useCentreInfo';
var FlexLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    target: "e1upzolw0",
    label: "FlexLink"
})("display:flex;text-decoration:none;grid-gap:10px;justify-content:flex-start;");
var LinkWithImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(FlexLink, {
    target: "e1upzolw1",
    label: "LinkWithImage"
})("margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_3B */ .t8.N, " !important;& > span{display:contents;}");
var AppImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_Image__WEBPACK_IMPORTED_MODULE_8__["default"], {
    target: "e1upzolw2",
    label: "AppImage"
})("border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_1B */ .t8.MK, ";");
var getProductsLinks = function(isApppleProduct) {
    return [
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(LinkWithImage, {
            href: "https://unacademy.onelink.me/vSdS/054lnfro",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(AppImage, {
                    src: "footer/learner.svg",
                    alt: "Learner app",
                    height: 24,
                    width: 24
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("span", {
                    children: "Learner app"
                })
            ]
        }, "Learner app"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(LinkWithImage, {
            href: isApppleProduct ? _layout_Footer_constants__WEBPACK_IMPORTED_MODULE_3__/* .EducatorAppLinks.APP_STORE */ .YU.APP_STORE : _layout_Footer_constants__WEBPACK_IMPORTED_MODULE_3__/* .EducatorAppLinks.PLAY_STORE */ .YU.PLAY_STORE,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(AppImage, {
                    src: "footer/educator.svg",
                    alt: "Educator app",
                    height: 24,
                    width: 24
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("span", {
                    children: "Educator app"
                })
            ]
        }, "Educator app"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(LinkWithImage, {
            href: "https://play.google.com/store/apps/details?id=com.unacademy.unacademyparentapp",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(AppImage, {
                    src: "footer/parent.svg",
                    alt: "Parent app",
                    height: 24,
                    width: 24
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("span", {
                    children: "Parent app"
                })
            ]
        }, "Parent app")
    ];
};
var getSection = function(isApppleProduct) {
    return [
        {
            title: "Company",
            list: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    underline: false,
                    href: "/about",
                    isRel: false,
                    children: "About Us"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    underline: false,
                    href: "/shikshodaya",
                    isRel: false,
                    children: "Shikshodaya"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    underline: false,
                    href: "/careers",
                    isRel: false,
                    children: "Careers"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    underline: false,
                    href: "https://blog.unacademy.com",
                    children: "Blogs"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    underline: false,
                    href: "/privacy",
                    isRel: false,
                    children: "Privacy policy"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    underline: false,
                    href: "/terms",
                    isRel: false,
                    children: "Terms and conditions"
                })
            ]
        },
        {
            title: "Help & support",
            list: _layout_Footer_constants__WEBPACK_IMPORTED_MODULE_3__/* .helpAndSupportLinks.map */ .$O.map(function(param) {
                var label = param.label, href = param.href;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    underline: false,
                    href: href,
                    isRel: false,
                    children: label
                });
            })
        },
        {
            title: "Company",
            list: getProductsLinks(isApppleProduct)
        },
        {
            title: "Popular goals",
            list: _layout_Footer_constants__WEBPACK_IMPORTED_MODULE_3__/* .popularGoalLinks.map */ .gw.map(function(param) {
                var label = param.label, href = param.href;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    underline: false,
                    href: href,
                    isRel: false,
                    children: label
                });
            })
        },
        {
            title: "Unacademy Centre",
            list: _layout_Footer_constants__WEBPACK_IMPORTED_MODULE_3__/* .unacademyCentreLinks.map */ .KF.map(function(param) {
                var label = param.label, href = param.href;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    underline: false,
                    href: "".concat(href, "?source=footer"),
                    isRel: false,
                    children: label
                });
            })
        },
        {
            title: "Study material",
            list: _layout_Footer_constants__WEBPACK_IMPORTED_MODULE_3__/* .studyMaterialLinks.map */ .nX.map(function(param) {
                var label = param.label, href = param.href;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    underline: false,
                    href: href,
                    isRel: false,
                    children: label
                });
            })
        }
    ];
};
var NewFooter = function(param) {
    var _mode = param.mode, mode = _mode === void 0 ? "dark" : _mode;
    var ref = _events_segmentStorage__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getItem */ .Z.getItem("systemInfo", _constants_empty__WEBPACK_IMPORTED_MODULE_6__/* .emptyObject */ .FD), systemOS = ref.os;
    var isApppleProduct = systemOS === _constants_support__WEBPACK_IMPORTED_MODULE_7__.OS.MacOS || systemOS === _constants_support__WEBPACK_IMPORTED_MODULE_7__.OS.iOS;
    var desc = "Unacademy is democratising education, making it accessible to all. Join the revolution, learn on India's largest learning platform.";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(aquilla_styled_StyleProvider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
        config: {
            mode: mode
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(aquilla_core_organisms_FooterLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            sections: getSection(isApppleProduct),
            phoneNumber: "+91 8585858585",
            desc: desc
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewFooter);


/***/ }),

/***/ 57498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _base_Button_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35415);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87936);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);
/* harmony import */ var _cont_Login_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43605);
/* harmony import */ var _stores_toggleables__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85690);
/* harmony import */ var _constants_toggleables__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28119);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _api_hooks_goal_useGoalInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27200);
/* harmony import */ var aquilla_core_molecules_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92378);
/* harmony import */ var _stores_selectors_login__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98964);
/* harmony import */ var _stores_login_loginStore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44545);
/* harmony import */ var _events_segmentStorage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71250);














var StyledDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Button_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e13239450",
    label: "StyledDiv"
})("grid-column:23/25;align-self:center;display:flex;", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{grid-column:22/25;min-height:32px;height:32px;}", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{color:var(--color-i-green);background-color:transparent;height:14px;width:auto;grid-column:7/9;&:active{background-color:transparent;border:none;transform:none;}}");
var LoginCTAWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e13239451",
    label: "LoginCTAWrapper"
})("display:flex;gap:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM, ";", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;justify-content:end;gap:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";}");
var NewLoginCTA = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(aquilla_core_molecules_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
    target: "e13239452",
    label: "NewLoginCTA"
})("padding:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_3B */ .t8.N, " ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_5B */ .t8.zj, ";width:104px;height:40px;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_6 */ .t8.A1, ";font-weight:600;font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.SMALL */ .F3.HC, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM, ";white-space:nowrap;", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{padding:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_14 */ .t8.Be, ";height:32px;width:unset;min-width:64px;max-width:96px;}");
var NewStyleButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(aquilla_core_molecules_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
    target: "e13239453",
    label: "NewStyleButton"
})("grid-column:23/25;align-self:center;display:flex;", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{grid-column:22/25;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_5B */ .t8.zj, ";min-width:unset;.button--label-content{font-weight:600;font-size:12px;line-height:16px;}}");
var acpfNudgeUrls = [
    "/goal/[goalSlug]/[goalUID]",
    "/goal/[goalSlug]/[goalUID]/home",
    "/goal/[goalSlug]/[goalUID]/subscriptions",
    "/goal/[goalSlug]/[goalUID]/success-story",
    "/goal/[goalSlug]/[goalUID]/store"
];
var Actions = function(param) {
    var isJoinForFreeCtaExperiment = param.isJoinForFreeCtaExperiment;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var isContentPage = (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.startsWith("/content/");
    var goalInfo = (0,_api_hooks_goal_useGoalInfo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(isContentPage ? (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.goalUID : null).goalInfo;
    var route = router.route;
    var setInitialAccountType = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_11__/* .getSetInitialAccountType */ .IX);
    var ref2 = (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_5__/* .useToggleable */ .F7)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_12__/* .LOGIN_DRAWER */ .es), openLoginDrawer = ref2.openElement;
    var login = function(e) {
        var ref;
        var ref1;
        _actions_analytics__WEBPACK_IMPORTED_MODULE_2__/* .segment.track */ .EX.track(_cont_Login_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOGIN_STARTED */ .ke, {
            cta_button: (ref1 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.textContent) !== null && ref1 !== void 0 ? ref1 : ""
        });
        /**
     * If the login is clicked from any Content pages that is housed in Unacademy WEB,
     * we trigger this event.
     */ if (isContentPage && goalInfo) {
            _actions_analytics__WEBPACK_IMPORTED_MODULE_2__/* .segment.track */ .EX.track("Content page - CTA clicked", {
                button_text: "Login",
                source_type: "content_pages",
                goal_name: goalInfo === null || goalInfo === void 0 ? void 0 : goalInfo.name,
                goal_uid: goalInfo === null || goalInfo === void 0 ? void 0 : goalInfo.uid
            });
        }
        openLoginDrawer();
    };
    var handleLogin = function(e) {
        _events_segmentStorage__WEBPACK_IMPORTED_MODULE_10__/* ["default"].setItem */ .Z.setItem("lpss", "Header");
        setInitialAccountType(_cont_Login_constants__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ACCOUNT_TYPE_LOGIN */ .ZP.ACCOUNT_TYPE_LOGIN);
        login(e);
    };
    var handleSignup = function(e) {
        setInitialAccountType(_cont_Login_constants__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ACCOUNT_TYPE_SIGNUP */ .ZP.ACCOUNT_TYPE_SIGNUP);
        login(e);
    };
    if (isJoinForFreeCtaExperiment) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(LoginCTAWrapper, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(NewLoginCTA, {
                    onClick: handleLogin,
                    variant: "secondary",
                    children: "Log in"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(NewLoginCTA, {
                    onClick: handleSignup,
                    children: "Join for free"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
        children: acpfNudgeUrls.includes(route) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(NewStyleButton, {
            onClick: handleLogin,
            children: "Log in"
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(StyledDiv, {
            label: "Log in",
            variant: "filled",
            onClick: handleLogin,
            grid: 2
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Actions);


/***/ }),

/***/ 13024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HeaderUser_HeaderUser; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./src/components/Base/H7/H7.jsx
var H7 = __webpack_require__(28197);
// EXTERNAL MODULE: ./src/components/Base/Dynamic/Dynamic.js + 2 modules
var Dynamic = __webpack_require__(28066);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/hooks/useEducatorContext.js
var useEducatorContext = __webpack_require__(49465);
// EXTERNAL MODULE: ./src/hooks/useLayoutOptions.js
var useLayoutOptions = __webpack_require__(73946);
// EXTERNAL MODULE: ./src/utils/textHelper.js
var textHelper = __webpack_require__(31309);
// EXTERNAL MODULE: ./src/hooks/usePlatformInfo.js
var usePlatformInfo = __webpack_require__(79592);
// EXTERNAL MODULE: ./src/api/selectors/constants.js
var constants = __webpack_require__(17064);
// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/api/hooks/useConstants.js
var useConstants = __webpack_require__(79917);
// EXTERNAL MODULE: ./src/api/hooks/activity/useActivityStats.js
var useActivityStats = __webpack_require__(71439);
// EXTERNAL MODULE: ./src/api/hooks/topology/useSelectedGoal.js
var useSelectedGoal = __webpack_require__(96487);
// EXTERNAL MODULE: ./src/components/Container/Compete/useCompeteConfig.js
var useCompeteConfig = __webpack_require__(94253);
// EXTERNAL MODULE: ./src/components/Container/ErrorBoundary/ErrorBoundary.jsx
var ErrorBoundary = __webpack_require__(65103);
// EXTERNAL MODULE: ./src/api/selectors/subscription.js
var subscription = __webpack_require__(58063);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./node_modules/aquilla/core/atoms/Typography/index.js
var Typography = __webpack_require__(82353);
// EXTERNAL MODULE: ./node_modules/aquilla/core/molecules/Button/index.js
var Button = __webpack_require__(92378);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Slide/Slide.js
var Slide = __webpack_require__(82285);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./node_modules/aquilla/icons/coach/AskADoubt.js
var AskADoubt = __webpack_require__(8622);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/Icons/Icon.jsx
var Icon = __webpack_require__(55447);
;// CONCATENATED MODULE: ./src/components/Icons/PlayIcon.jsx







var StyledIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Icon/* default */.Z, {
    target: "e1msxw5o0",
    label: "StyledIcon"
})("fill:none;height:24px;width:24px;");
var PlayIcon = function(props) {
    var color = props.color, rest = (0,_object_without_properties/* default */.Z)(props, [
        "color"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                clipPath: "url(#clip0_476_228378)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "24",
                        height: "24",
                        rx: "12",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        clipPath: "url(#clip1_476_228378)",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM16.4997 13.5588C17.6997 12.866 17.6997 11.1339 16.4997 10.4411L11.0997 7.32339C9.89971 6.63057 8.39971 7.49659 8.39971 8.88224V15.1176C8.39971 16.5033 9.89971 17.3693 11.0997 16.6765L16.4997 13.5588Z",
                            fill: "#34A4FF"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        id: "clip0_476_228378",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            width: "24",
                            height: "24",
                            rx: "12",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        id: "clip1_476_228378",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    })));
};
PlayIcon.propTypes = {
    color: (prop_types_default()).string
};
PlayIcon.defaultProps = {
    color: "var(--color-i-green)"
};
/* harmony default export */ var Icons_PlayIcon = (PlayIcon);

// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/layout/Header/HeaderUser/util.js
var util = __webpack_require__(13794);
// EXTERNAL MODULE: ./src/api/selectors/auth.js
var auth = __webpack_require__(73060);
;// CONCATENATED MODULE: ./src/components/Container/MeDashboard/IntroductionNudge.tsx






















var Transition = /*#__PURE__*/ react.forwardRef(function Transition(props, ref) {
    // @ts-ignore
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Slide/* default */.Z, (0,_object_spread/* default */.Z)({
        direction: "up",
        ref: ref
    }, props));
});
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "edeiyw50",
    label: "Wrapper"
})("padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "edeiyw51",
    label: "Title"
})("font-size:", styleConstants/* Spacings.SPACING_7B */.t8.d5, ";font-weight:", styleConstants/* Fonts.SEMIBOLD */.F3.rX, ";line-height:", styleConstants/* Spacings.SPACING_9B */.t8.No, ";margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";color:var(--color-base-fill);");
var StyP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Typography/* default */.ZP, {
    target: "edeiyw52",
    label: "StyP1"
})("max-width:384px;line-height:18px;");
var StyH6 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Typography/* default */.ZP, {
    target: "edeiyw53",
    label: "StyH6"
})("line-height:18px;font-weight:", styleConstants/* Fonts.SEMIBOLD */.F3.rX, ";");
var ItemsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "edeiyw54",
    label: "ItemsWrapper"
})("display:flex;flex-direction:column;justify-content:center;gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-top:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";margin-bottom:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";");
var Item = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "edeiyw55",
    label: "Item"
})("display:flex;flex-direction:row;align-items:center;gap:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyDialog = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Dialog/* default */.Z, {
    target: "edeiyw56",
    label: "StyDialog"
})("&.MuiDialog-root .MuiDialog-container .MuiPaper-root{bottom:0;background:var(--color-base-0);border-radius:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";max-height:none;width:464px;box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    color: "rgba(0, 0, 0, 0.12)"
}), ";}&.MuiDialog-root{overflow:scroll;}");
var InnerWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "edeiyw57",
    label: "InnerWrapper"
})("padding-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var StyButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.ZP, {
    target: "edeiyw58",
    label: "StyButton"
})("border-radius:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";height:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";width:140px;");
var Images = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "edeiyw59",
    label: "Images"
})("position:relative;");
var CloseIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "edeiyw510",
    label: "CloseIcon"
})("position:absolute;cursor:pointer;top:0;right:0;margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-right:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var IntroductionNudge = function(param) {
    var goalUID = param.goalUID, streakNewFlow = param.streakNewFlow, openStreaksDrawer = param.openStreaksDrawer;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), open = ref[0], setOpen = ref[1];
    var activityStats = (0,useActivityStats/* default */.Z)(goalUID).activityStats;
    var userId = (0,useMyInfo/* default */.Z)(auth/* getMeUserId */.bp);
    var questionsAttemptThreshold = activityStats.questionsAttemptThreshold, watchMinsThreshold = activityStats.watchMinsThreshold, _nudgeData = activityStats.nudgeData, nudgeData = _nudgeData === void 0 ? {} : _nudgeData;
    var header = nudgeData.header, description = nudgeData.description, imageUrl = nudgeData.imageUrl, id = nudgeData.id;
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    (0,react.useEffect)(function() {
        if (open) {
            analytics/* segment.track */.EX.track(util/* STREAKS_FEATURE_INTRODUCTION_VIEWED */.tM, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
                feature: "Streaks"
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    var closeDialog = function() {
        setOpen(false);
        (0,util/* storeStreaksNudgeInfo */.BY)(id, util/* nudgeTypes.ONBOARDING */.Vh.ONBOARDING, userId);
        analytics/* segment.track */.EX.track(util/* STREAKS_FEATURE_INTRODUCTION_DISMISS */.Zr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
            feature: "Streaks"
        }));
    };
    var openStreaks = function() {
        closeDialog();
        openStreaksDrawer();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyDialog, {
        open: open,
        // @ts-ignore
        TransitionComponent: Transition,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Images, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            src: imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.web,
                            width: "416px",
                            height: "227px",
                            alt: "Streaks"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseIcon, {
                            onClick: closeDialog,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                                src: "syllabus/close-icon.svg",
                                width: styleConstants/* Spacings.SPACING_7B */.t8.d5,
                                height: styleConstants/* Spacings.SPACING_7B */.t8.d5,
                                alt: "syllabus"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InnerWrapper, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                            children: header
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyP1, {
                            color: "var(--color-text-secondary)",
                            variant: "p2",
                            children: description
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemsWrapper, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons_PlayIcon, {}),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH6, {
                                            variant: "p2",
                                            color: "var(--color-text-primary)",
                                            children: "Watch ".concat(watchMinsThreshold, " mins of classes")
                                        })
                                    ]
                                }),
                                streakNewFlow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AskADoubt/* default */.ZP, {
                                            width: 24,
                                            height: 24
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH6, {
                                            variant: "p2",
                                            color: "var(--color-text-primary)",
                                            children: "Attempt ".concat(questionsAttemptThreshold, " questions")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyButton, {
                            // @ts-ignore
                            label: "View streaks",
                            size: "medium",
                            variant: "primary",
                            onClick: openStreaks
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var MeDashboard_IntroductionNudge = (IntroductionNudge);

// EXTERNAL MODULE: ./src/components/Icons/Close.jsx
var Close = __webpack_require__(112);
// EXTERNAL MODULE: ./src/stores/streaks/notificationStore.jsx
var notificationStore = __webpack_require__(22498);
// EXTERNAL MODULE: ./src/components/Icons/CheckCircle.jsx
var CheckCircle = __webpack_require__(22818);
// EXTERNAL MODULE: ./src/components/Composite/Streaks/StreakCircularProgressBar.jsx
var StreakCircularProgressBar = __webpack_require__(28204);
// EXTERNAL MODULE: ./src/components/Composite/Streaks/StreakCircles.tsx
var StreakCircles = __webpack_require__(49276);
;// CONCATENATED MODULE: ./src/components/Container/MeDashboard/NotificationNudge.tsx





















var NotificationNudge_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1e7o25f0",
    label: "Wrapper"
})("padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";background:var(--color-base-0);border:", styleConstants/* Spacings.SPACING_1 */.t8.tF, " solid var(--color-divider);box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";min-width:388px;position:absolute;z-index:10;top:", styleConstants/* Spacings.SPACING_20B */.t8.Ay, ";");
var NotificationNudge_StyP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Typography/* default */.ZP, {
    target: "e1e7o25f1",
    label: "StyP1"
})("max-width:260px;margin-top:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var StyH4 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Typography/* default */.ZP, {
    target: "e1e7o25f2",
    label: "StyH4"
})("font-weight:", styleConstants/* Fonts.HEAVY */.F3.XR, ";line-height:26px;margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var NotificationNudge_InnerWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1e7o25f3",
    label: "InnerWrapper"
})("display:flex;align-items:center;justify-content:space-between;");
var ItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1e7o25f4",
    label: "ItemWrapper"
})("display:flex;flex-direction:column;justify-content:center;gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-top:", function(param) {
    var $marginTop = param.$marginTop;
    return $marginTop;
}, ";");
var NotificationNudge_Item = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1e7o25f5",
    label: "Item"
})("display:flex;flex-direction:row;align-items:center;gap:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var StyClose = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Close["default"], {
    target: "e1e7o25f6",
    label: "StyClose"
})("cursor:pointer;");
var streaksInfo = function(param, streakNewFlow) {
    var _watchMinutes = param.watchMinutes, watchMinutes = _watchMinutes === void 0 ? 0 : _watchMinutes, _watchMinsThreshold = param.watchMinsThreshold, watchMinsThreshold = _watchMinsThreshold === void 0 ? 0 : _watchMinsThreshold, _questionsAttempted = param.questionsAttempted, questionsAttempted = _questionsAttempted === void 0 ? 0 : _questionsAttempted, _questionsAttemptThreshold = param.questionsAttemptThreshold, questionsAttemptThreshold = _questionsAttemptThreshold === void 0 ? 0 : _questionsAttemptThreshold;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemWrapper, {
        $marginTop: streakNewFlow ? styleConstants/* Spacings.SPACING_5B */.t8.zj : styleConstants/* Spacings.SPACING_4B */.t8.BM,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NotificationNudge_Item, {
                children: [
                    watchMinutes === watchMinsThreshold ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckCircle/* default */.Z, {
                        width: 20,
                        height: 20,
                        color: "var(--color-i-blue-streaks)"
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons_PlayIcon, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.ZP, {
                        variant: "h6",
                        children: "".concat(watchMinutes, " / ").concat(watchMinsThreshold, " minutes")
                    })
                ]
            }),
            streakNewFlow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NotificationNudge_Item, {
                children: [
                    questionsAttempted === questionsAttemptThreshold ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckCircle/* default */.Z, {
                        width: 20,
                        height: 20,
                        color: "var(--color-i-orange-streaks)"
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AskADoubt/* default */.ZP, {
                        width: 20,
                        height: 20
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.ZP, {
                        variant: "h6",
                        children: "".concat(questionsAttempted, " / ").concat(questionsAttemptThreshold, " questions")
                    })
                ]
            })
        ]
    });
};
var headerInfo = function(header, description) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH4, {
                variant: "h4",
                children: header
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationNudge_StyP1, {
                color: "var(--color-text-secondary)",
                variant: "p2",
                children: description
            })
        ]
    });
};
var NotificationNudge = function(param) {
    var goalUID = param.goalUID, activityStats = param.activityStats, dailyWatchMinPercentage = param.dailyWatchMinPercentage, questionsAttemptPercentage = param.questionsAttemptPercentage;
    // @ts-ignore
    var toggleShouldFetchActivityData = (0,notificationStore/* default */.Z)().toggleShouldFetchActivityData;
    var _experimentBucket = activityStats.experimentBucket, experimentBucket = _experimentBucket === void 0 ? {} : _experimentBucket, _nudgeData = activityStats.nudgeData, nudgeData = _nudgeData === void 0 ? {} : _nudgeData, nudgeType = activityStats.nudgeType;
    var id = nudgeData.id, header = nudgeData.header, description = nudgeData.description, imageUrl = nudgeData.imageUrl;
    var streakNewFlow = (0,util/* isStreaksNewFlow */.b5)(experimentBucket);
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    var userId = (0,useMyInfo/* default */.Z)(auth/* getMeUserId */.bp);
    (0,react.useEffect)(function() {
        analytics/* segment.track */.EX.track(util/* STREAK_REMINDER_VIEWED */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
            nudgeType: nudgeType
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onClose = function() {
        toggleShouldFetchActivityData(false);
        (0,util/* storeStreaksNudgeInfo */.BY)(id, nudgeType, userId);
    };
    var renderNewStreakNudge = function() {
        if (nudgeType === util/* nudgeTypes.STREAK_BROKEN */.Vh.STREAK_BROKEN) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NotificationNudge_InnerWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: headerInfo(header, description)
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    src: imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.web,
                    alt: "Streak Broken",
                    height: styleConstants/* Spacings.SPACING_20B */.t8.Ay,
                    width: styleConstants/* Spacings.SPACING_20B */.t8.Ay
                })
            ]
        });
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                headerInfo(header, description),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NotificationNudge_InnerWrapper, {
                    children: [
                        streaksInfo(activityStats, streakNewFlow),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StreakCircles/* default */.Z, {
                            height: 80,
                            width: 80,
                            outerSqSize: 80,
                            innerSqSize: 48,
                            outerStrokeWidth: 8,
                            innerStrokeWidth: 8,
                            dailyWatchMinPercentage: dailyWatchMinPercentage,
                            questionsAttemptPercentage: questionsAttemptPercentage
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NotificationNudge_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyClose, {
                height: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                width: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                onClick: onClose
            }),
            streakNewFlow ? renderNewStreakNudge() : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NotificationNudge_InnerWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            headerInfo(header, description),
                            streaksInfo(activityStats, streakNewFlow)
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StreakCircularProgressBar/* default */.Z, {
                        sqSize: 80,
                        percentage: dailyWatchMinPercentage,
                        strokeWidth: 10,
                        color: "var(--color-i-blue-streaks)",
                        outerPercentage: 100,
                        animate: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MeDashboard_NotificationNudge = (NotificationNudge);

// EXTERNAL MODULE: ./src/components/Container/MeDashboard/StreakItemV2.tsx
var StreakItemV2 = __webpack_require__(78280);
// EXTERNAL MODULE: ./src/api/hooks/goal/useGoalInfo.js
var useGoalInfo = __webpack_require__(27200);
// EXTERNAL MODULE: ./src/layout/Header/HeaderUser/ProfileOptions/ProfileOptions.jsx + 10 modules
var ProfileOptions = __webpack_require__(31991);
;// CONCATENATED MODULE: ./src/layout/Header/HeaderUser/HeaderUser.jsx

/* eslint-disable no-nested-ternary */ 



























var noStreakImageSrc = "layout/header/no_streak.svg";
var currentStreakImageSrc = "layout/header/current_streak.svg";
var longestStreakImageSrc = "layout/header/longest_streak.svg";
var MeDashboard = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 63116).then(__webpack_require__.bind(__webpack_require__, 63116));
});
var StreakPopup = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 53229).then(__webpack_require__.bind(__webpack_require__, 53229));
});
var noStreakAssets = {
    iconSrc: noStreakImageSrc,
    bg: "var(--color-i-gray-13)"
};
var currentStreakAssets = {
    iconSrc: currentStreakImageSrc,
    bg: "var(--color-i-blue)"
};
var HeaderUser_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1nb2fb80",
    label: "Wrapper"
})("position:relative;align-self:center;display:flex;justify-content:space-between;margin-right:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";padding:", styleConstants/* Spacings.SPACING_1B */.t8.MK, " 10px ", styleConstants/* Spacings.SPACING_1B */.t8.MK, " ", styleConstants/* Spacings.SPACING_3B */.t8.N, ";cursor:pointer;", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{grid-column:19/25;}");
var WrapperBg = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1nb2fb81",
    label: "WrapperBg"
})("position:absolute;left:0;top:0;width:100%;height:100%;border-radius:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";transition:opacity 300ms ease-in-out;background-color:", function(param) {
    var $bg = param.$bg;
    return $bg;
}, ";opacity:", function(param) {
    var $isActive = param.$isActive;
    return $isActive ? "0.15" : "0.05";
}, ";&:hover{opacity:0.15;}");
var LearnedMinutesContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1nb2fb82",
    label: "LearnedMinutesContainer"
})("display:flex;gap:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";align-items:center;visibility:", function(param) {
    var $isEducatorUrl = param.$isEducatorUrl;
    return $isEducatorUrl && "hidden";
}, ";");
var WatchMinsLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H7/* default */.Z, {
    target: "e1nb2fb83",
    label: "WatchMinsLabel"
})("line-height:16px;width:max-content;color:", function(props) {
    return props.$changeFontColor ? "var(--color-text-secondary)" : "";
}, ";");
var StreakContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(LearnedMinutesContainer, {
    target: "e1nb2fb84",
    label: "StreakContainer"
})("grid-column-gap:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";margin-left:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";width:max-content;");
var ActivityContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(LearnedMinutesContainer, {
    target: "e1nb2fb85",
    label: "ActivityContainer"
})("grid-column-gap:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";padding:", styleConstants/* Spacings.SPACING_1B */.t8.MK, " ", styleConstants/* Spacings.SPACING_3B */.t8.N, " ", styleConstants/* Spacings.SPACING_1B */.t8.MK, " ", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";gap:", styleConstants/* Spacings.SPACING_6 */.t8.A1, ";");
var HeaderUser = function(param) {
    var excludeOptions = param.excludeOptions, isUAIconsGoal = param.isUAIconsGoal, isCitySpecificOfflineCentre = param.isCitySpecificOfflineCentre;
    var isEducatorSide = (0,useEducatorContext/* default */.Z)();
    var ref = (0,react.useState)(false), showMeDashboard = ref[0], setShowMeDashboard = ref[1];
    var showCompeteBackground = (0,useCompeteConfig/* default */.Z)().showCompeteBackground;
    var onCloseMeDashboard = function() {
        return setShowMeDashboard(false);
    };
    var ref1 = (0,router.useRouter)(), _query = ref1.query, routeGoalUID = _query.goalUID;
    var selectedGoalUID = (0,useSelectedGoal/* useSelectedGoalUID */.Xm)();
    var goalUID = routeGoalUID || selectedGoalUID;
    var hideWatchMinForPlatform = (0,usePlatformInfo/* default */.Z)().hideWatchMinForPlatform;
    var isOfflineSubscription = (0,useMyInfo/* default */.Z)((0,subscription/* getIsSubscribedToOffline */.ZB)(goalUID));
    var userId = (0,useMyInfo/* default */.Z)(auth/* getMeUserId */.bp);
    var ref2 = (0,useActivityStats/* default */.Z)(goalUID), activityStats = ref2.activityStats, isValidating = ref2.isValidating, refetchActivityStats = ref2.mutate;
    var shouldFetchActivityData = (0,notificationStore/* default */.Z)().shouldFetchActivityData;
    var _watchMinutes = activityStats.watchMinutes, watchMinutes = _watchMinutes === void 0 ? 0 : _watchMinutes, _watchMinsThreshold = activityStats.watchMinsThreshold, watchMinsThreshold = _watchMinsThreshold === void 0 ? 0 : _watchMinsThreshold, _currentStreak = activityStats.currentStreak, currentStreak = _currentStreak === void 0 ? 0 : _currentStreak, _questionsAttempted = activityStats.// longestStreak = 0,
    questionsAttempted, questionsAttempted = _questionsAttempted === void 0 ? 0 : _questionsAttempted, _questionsAttemptThreshold = activityStats.questionsAttemptThreshold, questionsAttemptThreshold = _questionsAttemptThreshold === void 0 ? 0 : _questionsAttemptThreshold, _nudgeApplicable = activityStats.nudgeApplicable, nudgeApplicable = _nudgeApplicable === void 0 ? false : _nudgeApplicable, nudgeType = activityStats.nudgeType, _experimentBucket = activityStats.experimentBucket, experimentBucket = _experimentBucket === void 0 ? {} : _experimentBucket, _nudgeData = activityStats.nudgeData, nudgeData = _nudgeData === void 0 ? {} : _nudgeData;
    var id = nudgeData.id;
    // for free subscription nudges
    var goalInfo = (0,useGoalInfo/* default */.Z)(goalUID).goalInfo;
    var showStreaksNudge = nudgeApplicable && (0,util/* isStreaksNudgeVisible */.LM)(id, nudgeType, userId) && !isValidating;
    var isOnboardingNudge = nudgeType === util/* nudgeTypes.ONBOARDING */.Vh.ONBOARDING;
    var streakNewFlow = (0,util/* isStreaksNewFlow */.b5)(experimentBucket);
    var isNoStreak = currentStreak === 0;
    // eslint-disable-next-line no-nested-ternary
    var streakAssets = isNoStreak ? noStreakAssets : currentStreakAssets;
    var dailyWatchMinPercentage = watchMinsThreshold && watchMinutes ? watchMinutes * 100 / watchMinsThreshold : 0;
    var questionsAttemptPercentage = questionsAttempted && questionsAttemptThreshold ? questionsAttempted * 100 / questionsAttemptThreshold : 0;
    var isGTP = (0,useConstants/* default */.Z)((0,constants/* getIsGTPGoal */.vf)(selectedGoalUID));
    var isDailyMinStreakCompleted = !!(dailyWatchMinPercentage === 100);
    var isStreakCompleted = streakNewFlow ? isDailyMinStreakCompleted && questionsAttemptPercentage === 100 : isDailyMinStreakCompleted;
    (0,react.useEffect)(function() {
        if (shouldFetchActivityData) refetchActivityStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldFetchActivityData
    ]);
    var hideLearnerMinutes = (0,useLayoutOptions/* useFlagSelector */.v)("hideLearnerMinutes") || isEducatorSide || isGTP || hideWatchMinForPlatform || isUAIconsGoal || isCitySpecificOfflineCentre;
    var ref3 = (0,react.useState)(null), streakPopupAnchor = ref3[0], setStreakPopupAnchor = ref3[1];
    var openStreakPopup = function(e) {
        if (hideLearnerMinutes) return;
        setStreakPopupAnchor(e.currentTarget);
    };
    var closeStreakPopup = function() {
        if (hideLearnerMinutes) return;
        setStreakPopupAnchor(null);
    };
    var openMeDashboard = function() {
        closeStreakPopup();
        setShowMeDashboard(true);
    };
    var getPopUp = function() {
        if ((goalInfo === null || goalInfo === void 0 ? void 0 : goalInfo.trialExpiryPopUpShown) === undefined) return false;
        return true;
    };
    var showStreakPopup = !!streakPopupAnchor;
    var shownFreeTrialNudge = getPopUp();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            !hideLearnerMinutes && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundary/* default */.Z, {
                children: !isOfflineSubscription ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderUser_Wrapper, {
                            onClick: showStreakPopup ? closeStreakPopup : openStreakPopup,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WrapperBg, {
                                    $bg: streakAssets.bg,
                                    $isActive: showStreakPopup
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LearnedMinutesContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StreakItemV2/* default */.Z, {
                                            size: 20,
                                            outerSqSize: 20,
                                            innerSqSize: 14,
                                            isStreaksNewFlow: streakNewFlow,
                                            dailyWatchMinPercentage: dailyWatchMinPercentage,
                                            questionsAttemptPercentage: questionsAttemptPercentage,
                                            strokeWidth: 2,
                                            isCompleted: isStreakCompleted
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WatchMinsLabel, {
                                            $changeFontColor: showCompeteBackground,
                                            children: "".concat(watchMinutes, " min")
                                        }),
                                        streakNewFlow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WatchMinsLabel, {
                                            $changeFontColor: showCompeteBackground,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    children: "\xb7"
                                                }),
                                                " ".concat(questionsAttempted, " Q").concat(questionsAttempted === 1 ? "" : "s")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StreakContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                                            src: streakAssets.iconSrc,
                                            alt: "streak",
                                            width: 20,
                                            height: 20
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WatchMinsLabel, {
                                            $changeFontColor: showCompeteBackground,
                                            children: (0,textHelper/* pluralize */._6)(currentStreak, "day")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StreakPopup, {
                                    openMeDashboard: openMeDashboard,
                                    activityStats: activityStats,
                                    onClose: closeStreakPopup,
                                    anchorEl: streakPopupAnchor
                                })
                            ]
                        }),
                        !shownFreeTrialNudge && showStreaksNudge && isOnboardingNudge && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MeDashboard_IntroductionNudge, {
                            goalUID: goalUID,
                            streakNewFlow: streakNewFlow,
                            openStreaksDrawer: openMeDashboard
                        }),
                        showStreaksNudge && shouldFetchActivityData && !isOnboardingNudge && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MeDashboard_NotificationNudge, {
                            goalUID: goalUID,
                            activityStats: activityStats,
                            dailyWatchMinPercentage: dailyWatchMinPercentage,
                            questionsAttemptPercentage: questionsAttemptPercentage
                        })
                    ]
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderUser_Wrapper, {
                    onClick: openMeDashboard,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WrapperBg, {
                            $bg: "var(--color-i-orange-1)"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ActivityContainer, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                                    src: longestStreakImageSrc,
                                    alt: "activity",
                                    width: 18,
                                    height: 24
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WatchMinsLabel, {
                                    children: " Activity "
                                })
                            ]
                        })
                    ]
                })
            }),
            shownFreeTrialNudge,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileOptions["default"], {
                excludeOptions: excludeOptions,
                closeStreakPopup: closeStreakPopup
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MeDashboard, {
                    showDashboard: showMeDashboard,
                    onClose: onCloseMeDashboard
                })
            })
        ]
    });
};
/* harmony default export */ var HeaderUser_HeaderUser = (HeaderUser);
HeaderUser.propTypes = {
    excludeOptions: prop_types_default().arrayOf((prop_types_default()).string),
    isUAIconsGoal: (prop_types_default()).bool
};
HeaderUser.defaultProps = {
    excludeOptions: [],
    isUAIconsGoal: false
};


/***/ }),

/***/ 13794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BY": function() { return /* binding */ storeStreaksNudgeInfo; },
/* harmony export */   "II": function() { return /* binding */ STREAK_REMINDER_VIEWED; },
/* harmony export */   "LM": function() { return /* binding */ isStreaksNudgeVisible; },
/* harmony export */   "Vh": function() { return /* binding */ nudgeTypes; },
/* harmony export */   "ZN": function() { return /* binding */ STREAK_DAILY_GOAL_VIEWED; },
/* harmony export */   "Zr": function() { return /* binding */ STREAKS_FEATURE_INTRODUCTION_DISMISS; },
/* harmony export */   "b5": function() { return /* binding */ isStreaksNewFlow; },
/* harmony export */   "sc": function() { return /* binding */ STREAK_DAILY_GOAL_HISTORY; },
/* harmony export */   "tM": function() { return /* binding */ STREAKS_FEATURE_INTRODUCTION_VIEWED; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _utils_localStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77090);


var oneDay = 24 * 60 * 60 * 1000;
var nowInMs = function() {
    return new Date().getTime();
};
var isStreaksNewFlow = function() {
    var experimentBucket = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var streakNewDefinition = experimentBucket.streakNewDefinition;
    return streakNewDefinition === "Test1";
};
var nudgeTypes = {
    ONBOARDING: 1,
    GRACE_PERIOD: 2,
    STREAK_BROKEN: 3
};
var storeStreaksNudgeInfo = function(id, nudgeType, userId) {
    if ((0,_utils_localStorage__WEBPACK_IMPORTED_MODULE_0__/* .localStorageAvailable */ .V)()) {
        var streakNudges = localStorage.getItem("streakNudges");
        var streakNudgesObj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, JSON.parse(streakNudges));
        streakNudgesObj["".concat(userId, "-").concat(id, "-").concat(nudgeType)] = nowInMs();
        localStorage.setItem("streakNudges", JSON.stringify(streakNudgesObj));
    }
};
var isStreaksNudgeVisible = function(id, nudgeType, userId) {
    if ((0,_utils_localStorage__WEBPACK_IMPORTED_MODULE_0__/* .localStorageAvailable */ .V)()) {
        var streakNudges = localStorage.getItem("streakNudges");
        var streakNudgesObj = JSON.parse(streakNudges);
        if (!streakNudgesObj) return true;
        var timeStamp = streakNudgesObj["".concat(userId, "-").concat(id, "-").concat(nudgeType)];
        return timeStamp ? nowInMs() - timeStamp >= oneDay : true;
    }
    return true;
};
var STREAKS_FEATURE_INTRODUCTION_VIEWED = "Feature Introduction - Bottom Sheet Viewed";
var STREAKS_FEATURE_INTRODUCTION_DISMISS = "Feature Introduction - Bottom Sheet Dismissed";
var STREAK_DAILY_GOAL_VIEWED = "Streak - Daily Goal Viewed";
var STREAK_DAILY_GOAL_HISTORY = "Streak - Daily Goal History";
var STREAK_REMINDER_VIEWED = "Streak - Reminder Viewed";


/***/ }),

/***/ 45611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85780);
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18113);
/* harmony import */ var _skeletons_RoundedRectSkeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96814);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95934);
/* harmony import */ var _Actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57498);







var LoginSkeletonRapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_4__["default"])("div", {
    target: "e6qsr200",
    label: "LoginSkeletonRapper"
})("display:flex;gap:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM, ";", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;justify-content:end;gap:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";}");
var RenderLoginAction = function(param) {
    var _show = param.show, show = _show === void 0 ? true : _show, isJoinForFreeCtaExperiment = param.isJoinForFreeCtaExperiment;
    var ref = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), failedToFetchUserData = ref.isError, fetchingUserData = ref.isValidating;
    var hideLoginButton = !show;
    if (hideLoginButton) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {});
    if (!failedToFetchUserData && (fetchingUserData || (0,_utils_cookies__WEBPACK_IMPORTED_MODULE_1__/* .readCookie */ .vQ)("accessToken"))) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(LoginSkeletonRapper, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_skeletons_RoundedRectSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                height: 25,
                width: 25
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_Actions__WEBPACK_IMPORTED_MODULE_5__["default"], {
        isJoinForFreeCtaExperiment: isJoinForFreeCtaExperiment
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RenderLoginAction);


/***/ }),

/***/ 88914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NewGoalLayout_NewGoalLayout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/aquilla/styled/StyleProvider.js
var StyleProvider = __webpack_require__(12848);
// EXTERNAL MODULE: ./src/layout/Footer/NewFooter.jsx
var NewFooter = __webpack_require__(56608);
// EXTERNAL MODULE: ./src/stores/ttu.js
var ttu = __webpack_require__(94835);
// EXTERNAL MODULE: ./src/stores/selectors/ttuSelectors.js
var ttuSelectors = __webpack_require__(29870);
// EXTERNAL MODULE: ./src/components/Base/Dynamic/Dynamic.js + 2 modules
var Dynamic = __webpack_require__(28066);
// EXTERNAL MODULE: ./src/constants/empty.js
var empty = __webpack_require__(59375);
// EXTERNAL MODULE: ./src/stores/AppCommonData.jsx + 1 modules
var AppCommonData = __webpack_require__(83995);
// EXTERNAL MODULE: ./src/api/fetchers/ttu/index.js
var fetchers_ttu = __webpack_require__(57001);
// EXTERNAL MODULE: ./src/layout/TTUWidgetRenderer.jsx
var TTUWidgetRenderer = __webpack_require__(66583);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Composite/Logo/Logo.jsx + 1 modules
var Logo = __webpack_require__(50648);
// EXTERNAL MODULE: ./src/layout/Components/HeaderContainer.jsx
var HeaderContainer = __webpack_require__(40101);
// EXTERNAL MODULE: ./src/layout/Components/HeaderParent.jsx
var HeaderParent = __webpack_require__(47731);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/stores/toggleables.js
var toggleables = __webpack_require__(85690);
// EXTERNAL MODULE: ./src/constants/toggleables.js
var constants_toggleables = __webpack_require__(28119);
// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/api/selectors/auth.js
var auth = __webpack_require__(73060);
// EXTERNAL MODULE: ./node_modules/aquilla/core/molecules/Tabs/index.js
var Tabs = __webpack_require__(77268);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./src/components/Base/Tooltip/Tooltip.jsx
var Tooltip = __webpack_require__(89116);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(50420);
// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
// EXTERNAL MODULE: ./src/hooks/useFirstRenderSkip.js
var useFirstRenderSkip = __webpack_require__(6858);
// EXTERNAL MODULE: ./src/stores/headerNudge.js
var headerNudge = __webpack_require__(27961);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/utils/localStorage.js
var utils_localStorage = __webpack_require__(77090);
;// CONCATENATED MODULE: ./src/components/Composite/ReferralNudge/ReferralNudge.jsx
















var HeaderReferralToolTip = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Tooltip/* default */.Z, {
    target: "e1fdr0vu0",
    label: "HeaderReferralToolTip"
})("z-index:1200;.MuiTooltip-tooltip{padding:", styleConstants/* Spacings.SPACING_0B */.t8.NE, ";border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{&.MuiTooltip-popper{z-index:1100;}.MuiTooltip-tooltip{padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-right:-", styleConstants/* Spacings.SPACING_3B */.t8.N, ";}}");
var ReferralWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1fdr0vu1",
    label: "ReferralWrapper"
})(function(param) {
    var $isLoggedIn = param.$isLoggedIn;
    return $isLoggedIn ? "width:".concat(styleConstants/* Spacings.SPACING_8B */.t8.B3, "; height:").concat(styleConstants/* Spacings.SPACING_8B */.t8.B3, ";") : "width:".concat(styleConstants/* Spacings.SPACING_10B */.t8.FC, "; height:").concat(styleConstants/* Spacings.SPACING_10B */.t8.FC, ";");
}, "  position:relative;margin-right:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-left:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{margin:", styleConstants/* Spacings.SPACING_0B */.t8.NE, " ", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";width:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";height:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";}");
var ReferralButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.Z, {
    target: "e1fdr0vu2",
    label: "ReferralButtonWrapper"
})("display:none;&.MuiButton-label{width:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";}&.show-referral-button{display:contents;width:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";height:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";}");
var CoachmarkContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1fdr0vu3",
    label: "CoachmarkContainer"
})("padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";width:220px;");
var CoachmarkTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1fdr0vu4",
    label: "CoachmarkTextWrapper"
})("font-weight:", styleConstants/* Fonts.SEMIBOLD */.F3.rX, ";font-size:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";line-height:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";text-align:center;letter-spacing:-0.005em;color:var(--color-i-white);");
var ReferralNudge = function(param) {
    var isExpanded = param.isExpanded;
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var ref = (0,react.useState)(false), openToolTip = ref[0], setOpenToolTip = ref[1];
    var ref1 = (0,react.useState)(false), isAlreadyVisible = ref1[0], setIsAlreadyVisible = ref1[1];
    var isPaymentNudge = (0,headerNudge/* default */.Z)().isPaymentNudge;
    (0,react.useEffect)(function() {
        if ((0,utils_localStorage/* localStorageAvailable */.V)()) {
            if (localStorage.getItem("openHeaderToolTip") === "true") {
                setIsAlreadyVisible(true);
            }
        }
    }, []);
    (0,useFirstRenderSkip/* default */.Z)(function() {
        if ((0,utils_localStorage/* localStorageAvailable */.V)()) {
            var storeToolTipShown = localStorage.getItem("storeToolTipShown") || localStorage.getItem("storeTooltipStatus") === "clicked";
            if (!isPaymentNudge && storeToolTipShown) {
                localStorage.setItem("openHeaderToolTip", "true");
                setOpenToolTip(true);
            } else {
                setOpenToolTip(false);
            }
        }
    }, [
        isLoggedIn,
        isMobile,
        isPaymentNudge
    ]);
    var handleRedirect = function() {
        analytics/* segment.track */.EX.track(segment/* REFERRAL_TOUCHPOINT_CLICKED */.Dzh, {
            last_primary_source_section: segment/* REFERRAL_TOPBAR_TOUCHPOINT */.Y8G
        });
        var path = isLoggedIn ? "/settings/referral" : "/referral";
        (0,pushRoute/* default */.Z)(path, path);
    };
    var tooltipContent = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CoachmarkContainer, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CoachmarkTextWrapper, {
            children: "Refer & earn rewards upto \u20B925,000"
        })
    });
    (0,react.useEffect)(function() {
        if (openToolTip && !isAlreadyVisible && !isPaymentNudge && !isMobile) {
            var timeout = setTimeout(function() {
                setOpenToolTip(false);
            }, 5000);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        isAlreadyVisible,
        isMobile,
        isPaymentNudge,
        openToolTip
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderReferralToolTip, {
        open: openToolTip && !isAlreadyVisible && !isPaymentNudge && !isMobile,
        title: tooltipContent,
        backgroundColor: "#2D81F7",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReferralWrapper, {
            $isLoggedIn: isLoggedIn,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReferralButtonWrapper, {
                className: isExpanded ? "" : "show-referral-button",
                onClick: handleRedirect,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                    src: "newGoalHeaderGift.svg",
                    layout: "fill",
                    alt: "avatar"
                })
            })
        })
    });
};
/* harmony default export */ var ReferralNudge_ReferralNudge = (ReferralNudge);

// EXTERNAL MODULE: ./src/components/Container/NewPreSubscribed/constants.js
var constants = __webpack_require__(84566);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/hooks/useFetch.js
var useFetch = __webpack_require__(68826);
// EXTERNAL MODULE: ./src/utils/api-helper/host.js
var host = __webpack_require__(54051);
;// CONCATENATED MODULE: ./src/api/hooks/useSeoContent.js


/* eslint-disable react-hooks/exhaustive-deps */ 

var useSeoContent = function(pageType, itemId) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        fallbackData: undefined
    };
    var key = "api/meta-data/".concat(pageType, "/").concat(itemId);
    var _ref = (0,useFetch/* default */.Z)(itemId ? key : null, {
        hostType: host/* HOST_TYPE.CMS */.Bk.CMS
    }, {
        fallbackData: options.fallbackData
    }), seoContent = _ref.data, isValidating = _ref.isValidating, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "data",
        "isValidating"
    ]);
    return (0,_object_spread/* default */.Z)({
        key: key,
        seoContent: seoContent,
        isValidating: isValidating
    }, rest);
};
/* harmony default export */ var hooks_useSeoContent = (useSeoContent);

// EXTERNAL MODULE: ./src/components/Container/StoreListing/constants.js
var StoreListing_constants = __webpack_require__(57394);
// EXTERNAL MODULE: ./node_modules/aquilla/core/atoms/Typography/index.js
var Typography = __webpack_require__(82353);
// EXTERNAL MODULE: ./src/api/hooks/topology/useTopology.js
var useTopology = __webpack_require__(71609);
// EXTERNAL MODULE: ./src/components/Container/Login/LoginComponent.jsx
var LoginComponent = __webpack_require__(34085);
// EXTERNAL MODULE: ./src/components/Container/Login/utils/hooks/useLoginModalExperiment.js
var useLoginModalExperiment = __webpack_require__(80560);
;// CONCATENATED MODULE: ./src/components/Container/Store/useStoreNudge.js




var useStoreNudge = function(param) {
    var showStoreTab = param.showStoreTab;
    var isMobile = (0,AppCommonData/* useIsMobile */.dD)();
    var ref = (0,react.useState)(false), showStoreTooltip = ref[0], setShowStoreTooltip = ref[1];
    var isPaymentNudge = (0,headerNudge/* default */.Z)().isPaymentNudge;
    var checkForStoreNudge = (0,react.useCallback)(function() {
        if (!isMobile && !isPaymentNudge && (0,utils_localStorage/* localStorageAvailable */.V)() && !localStorage.getItem("storeToolTipShown") && showStoreTab) {
            setShowStoreTooltip(true);
            localStorage.setItem("storeToolTipShown", "true");
        }
    }, [
        isPaymentNudge,
        showStoreTab,
        isMobile
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("scroll", checkForStoreNudge);
        return function() {
            document.removeEventListener("scroll", checkForStoreNudge);
        };
    }, [
        checkForStoreNudge
    ]);
    return {
        showStoreTooltip: showStoreTooltip
    };
};
/* harmony default export */ var Store_useStoreNudge = (useStoreNudge);

// EXTERNAL MODULE: ./src/layout/Header/HeaderUser/HeaderUser.jsx + 3 modules
var HeaderUser = __webpack_require__(13024);
// EXTERNAL MODULE: ./node_modules/aquilla/core/molecules/Search/index.js
var Search = __webpack_require__(17372);
// EXTERNAL MODULE: ./src/api/hooks/search/useRecentSearches.js
var useRecentSearches = __webpack_require__(47154);
// EXTERNAL MODULE: ./src/api/hooks/search/usePopularSearches.js
var usePopularSearches = __webpack_require__(74705);
// EXTERNAL MODULE: ./src/api/hooks/search/useAutoCompleteResults.js
var useAutoCompleteResults = __webpack_require__(46024);
// EXTERNAL MODULE: ./src/utils/uuid.js
var uuid = __webpack_require__(92714);
// EXTERNAL MODULE: ./src/utils/cookies.js
var cookies = __webpack_require__(18113);
// EXTERNAL MODULE: ./src/constants/index.js
var src_constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/stores/selectors/common.js
var common = __webpack_require__(43578);
;// CONCATENATED MODULE: ./src/layout/Header/NewSearchTab.jsx






















var TrendingSearch = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 53941).then(__webpack_require__.bind(__webpack_require__, 53941));
});
var RecentSearch = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(73042), __webpack_require__.e(10249)]).then(__webpack_require__.bind(__webpack_require__, 10249));
});
var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ereyga70",
    label: "Container"
})("display:flex;z-index:5;");
var StyledSearchWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Search/* default */.ZP, {
    target: "ereyga71",
    label: "StyledSearchWrapper"
})("flex:1;margin-right:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";.aquilla-combobox{> div > div{height:40px;}svg{color:var(--color-text-secondary);}}");
var StyledSearchListWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Search/* SearchList */.Dl, {
    target: "ereyga72",
    label: "StyledSearchListWrapper"
})("left:unset !important;height:unset;margin-top:", styleConstants/* Spacings.SPACING_0B */.t8.NE, ";border-radius:0 0 ", styleConstants/* Spacings.SPACING_2B */.t8.Rw, " ", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";border:none;z-index:5;");
var NewSearchTab = function() {
    var ref = (0,react.useState)(""), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(false), showDropdown = ref1[0], setShowDropdown = ref1[1];
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var ref2 = (0,router.useRouter)(), goalUID = ref2.query.goalUID;
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    var currentPageName = (0,AppCommonData/* usePageInfo */.TN)(common/* getCurrentPageName */.d6);
    var ref3 = (0,react.useState)(false), fetchRecentSearches = ref3[0], setFetchRecentSearches = ref3[1];
    var ref4 = (0,react.useState)(""), autoCompleteQueryToFetchWith = ref4[0], setAutoCompleteQueryToFetchWith = ref4[1];
    var debouncingRef = (0,react.useRef)(null);
    var recentSearches = (0,useRecentSearches/* default */.Z)(goalUID, fetchRecentSearches).recentSearches;
    var popularSearches = (0,usePopularSearches/* default */.Z)().popularSearches;
    var showRecentSearches = (0,react.useMemo)(function() {
        return isLoggedIn && !!(recentSearches === null || recentSearches === void 0 ? void 0 : recentSearches.length);
    }, [
        isLoggedIn,
        recentSearches === null || recentSearches === void 0 ? void 0 : recentSearches.length
    ]);
    var popularSearch = (0,react.useMemo)(function() {
        var ref;
        return showRecentSearches ? recentSearches : (popularSearches === null || popularSearches === void 0 ? void 0 : (ref = popularSearches.slice) === null || ref === void 0 ? void 0 : ref.call(popularSearches, 0, 10)) || [];
    }, [
        showRecentSearches,
        recentSearches,
        popularSearches
    ]);
    var changeHandler = function(autoCompleteQuery) {
        if (debouncingRef.current) clearTimeout(debouncingRef.current);
        debouncingRef.current = setTimeout(function() {
            return setAutoCompleteQueryToFetchWith(autoCompleteQuery);
        }, 300);
    };
    var autoCompleteResults = (0,useAutoCompleteResults/* default */.Z)(autoCompleteQueryToFetchWith).autoCompleteResults;
    var searchResults = value ? autoCompleteResults : popularSearch;
    var SearchDropdown = !value && showRecentSearches ? RecentSearch : TrendingSearch;
    (0,react.useEffect)(function() {
        if (showDropdown) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "auto";
    }, [
        showDropdown
    ]);
    var handleOnChange = function(changedValue) {
        setValue(changedValue);
        changeHandler(changedValue);
    };
    var handleOnClear = function() {
        setValue("");
    };
    var handleOpenSearch = function() {
        var tpID = (0,uuid/* default */.Z)();
        var twoMinutesFromNow = new Date(new Date().getTime() + 120 * 1000);
        (0,cookies/* setCookie */.d8)("tapID", tpID, twoMinutesFromNow); // Delete cookie in 2 minutes.
        analytics/* segment.track */.EX.track(segment/* SEARCH_CLICKED */.qH0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
            tap_id: tpID,
            search_section: "Global",
            version: 2,
            last_primary_source: currentPageName
        }), src_constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY);
        setShowDropdown(true);
        setFetchRecentSearches(true);
    };
    var handleCloseSearch = function() {
        setShowDropdown(false);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSearchWrapper, {
            onOpen: handleOpenSearch,
            onClose: handleCloseSearch,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Search/* SearchInput */.Mj, {
                    value: value,
                    onChange: handleOnChange,
                    onClear: handleOnClear,
                    placeholder: "Search courses, test series and educators",
                    className: "seachInput"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSearchListWrapper, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchDropdown, {
                        popularSearches: searchResults
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Header_NewSearchTab = (NewSearchTab);

// EXTERNAL MODULE: ./src/layout/Header/RenderLoginAction.jsx
var RenderLoginAction = __webpack_require__(45611);
;// CONCATENATED MODULE: ./src/layout/Header/NewGoalHeader.jsx




/* eslint-disable max-lines */ 
































var GoalSelector = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1314), __webpack_require__.e(90458), __webpack_require__.e(51599)]).then(__webpack_require__.bind(__webpack_require__, 90458));
});
var PaymentNudge = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(34040), __webpack_require__.e(11083)]).then(__webpack_require__.bind(__webpack_require__, 34040));
});
var StoreTooltip = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 21325).then(__webpack_require__.bind(__webpack_require__, 21325));
});
var NewGoalHeader_HeaderContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(HeaderContainer/* default */.Z, {
    target: "e1qfn6d70",
    label: "HeaderContainer"
})("z-index:2;background:", function(param) {
    var transparent = param.transparent, hideBgColor = param.hideBgColor;
    return transparent || hideBgColor ? "none" : "var(--color-base-1)";
}, ";border-bottom:1px solid #e9eef2;position:", function(param) {
    var transparent = param.transparent;
    return transparent ? "absolute" : "sticky";
}, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{height:auto;}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:block;width:100%;background-color:var(--color-base-1);margin-bottom:0px;}height:64px;margin-bottom:57px;");
var LogoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d71",
    label: "LogoWrapper"
})("[class*='LogoContainer']{display:flex;}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:none;}");
var SearchWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d72",
    label: "SearchWrapper"
})("flex:1;", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{display:none;}");
var RightContentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d73",
    label: "RightContentWrapper"
})("display:flex;align-items:center;flex-basis:264px;justify-content:flex-end;grid-column:2/3;[aria-label='Login']{background-color:var(--color-base-fill);", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{color:var(--color-text-tertiary);background-color:var(--color-base-fill);width:72px;}}");
var HeaderUserContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d74",
    label: "HeaderUserContainer"
})("display:flex;align-items:center;justify-content:flex-end;");
var GoalSelectorWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d75",
    label: "GoalSelectorWrapper"
})("display:flex;align-items:center;flex-basis:232px;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{max-width:90px;flex:1;justify-content:flex-start;margin-right:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";button{padding-left:0px;}}");
var TabWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d76",
    label: "TabWrapper"
})("height:100%;.aquilla-tablist{justify-content:flex-start;}", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{padding:0 ", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";.aquilla-tablist{justify-content:flex-start;}}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{padding:0 ", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";}> *{height:100%;}");
var LoginProfileWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d77",
    label: "LoginProfileWrapper"
})();
var NewGoalHeader_HeaderParent = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(HeaderParent/* default */.Z, {
    target: "e1qfn6d78",
    label: "HeaderParent"
})("position:relative;justify-content:space-between;display:grid;grid-template-columns:260px 1fr;", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{width:100%;display:flex;padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, " ", styleConstants/* Spacings.SPACING_8B */.t8.B3, " 0\n      ", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{height:56px;display:flex;width:100%;padding:16px;justify-content:space-between;}", GoalSelectorWrapper, ",", LoginProfileWrapper, ",", LogoWrapper, ",", TabWrapper, "{transition:all linear 300ms;}");
var LogoGoalSelectorWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d79",
    label: "LogoGoalSelectorWrapper"
})("display:flex;align-items:center;flex-basis:264px;", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{gap:0;}");
var ScreenWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d710",
    label: "ScreenWrapper"
})("height:100%;&.desktop{display:block;", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{display:none;}}&.mobile{display:none;", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{display:block;}}");
var TabSubContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d711",
    label: "TabSubContainer"
})("width:1136px;margin:0 auto;.tablist{min-height:32px;}.aquilla-tab{min-height:32px;height:32px;}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{.tablist{min-height:40px;}.aquilla-tab{min-height:40px;height:40px;}}");
var TabContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d712",
    label: "TabContainer"
})("width:100%;background:#ffffff;position:relative;z-index:2;border-bottom:", styleConstants/* Spacings.SPACING_1 */.t8.tF, " solid #e9eef2;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:none;}");
var TabLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d713",
    label: "TabLabel"
})("display:flex;gap:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";align-items:center;");
var NewTag = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d714",
    label: "NewTag"
})("height:", styleConstants/* Spacings.SPACING_14 */.t8.Be, ";display:flex;align-items:center;color:var(--color-i-blue);font-size:", styleConstants/* Fonts.EXTRA_SMALL */.F3.y2, ";font-weight:", styleConstants/* Fonts.HEAVY */.F3.XR, ";border-radius:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";padding:", styleConstants/* Spacings.SPACING_2 */.t8.Jl, " ", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";background-color:var(--color-i-blue-27);");
var ContactWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d715",
    label: "ContactWrapper"
})("display:flex;padding:", styleConstants/* Spacings.SPACING_0B */.t8.NE, " ", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{display:none;}");
var PhoneWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qfn6d716",
    label: "PhoneWrapper"
})("text-align:center;");
var Phone = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("a", {
    target: "e1qfn6d717",
    label: "Phone"
})("display:flex;width:fit-content;");
var IconWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("a", {
    target: "e1qfn6d718",
    label: "IconWrapper"
})("display:flex;justify-content:center;align-items:center;");
var RenderTabs = function(param) {
    var handleOnChange = param.handleOnChange, currentTabIndex = param.currentTabIndex, showStoreTooltip = param.showStoreTooltip, headerTabs = param.headerTabs;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs/* Tabs */.mQ, {
            onChange: handleOnChange,
            index: currentTabIndex,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs/* TabList */.td, {
                children: headerTabs.map(function(tab) {
                    var tabElement = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs/* Tab */.OK, {
                        id: tab.id,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabLabel, {
                            children: [
                                tab.label,
                                constants/* STORE_TAB.id */.Y7.id === tab.id && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewTag, {
                                    children: "NEW"
                                })
                            ]
                        })
                    }, tab.id);
                    if (tab.id === constants/* STORE_TAB.id */.Y7.id && showStoreTooltip) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoreTooltip, {
                        children: tabElement
                    });
                    return tabElement;
                })
            })
        })
    });
};
var ContactUs = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContactWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
                href: "tel:918585858585",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                    src: "goal/callUs.svg",
                    width: "40",
                    height: "40",
                    alt: "call-us"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PhoneWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.ZP, {
                        variant: "p3",
                        color: "var(--color-text-secondary)",
                        children: "Talk to our experts"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Phone, {
                        href: "tel:918585858585",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.ZP, {
                            variant: "h6",
                            children: "+91-8585858585"
                        })
                    })
                ]
            })
        ]
    });
};
var NewGoalHeader = function(param) {
    var transparent = param.transparent, isReload = param.isReload, disabled = param.disabled, pageMetaInfo = param.pageMetaInfo;
    var ref = (0,toggleables/* useToggleable */.F7)(constants_toggleables/* LOGIN_DRAWER */.es), showLoginDrawer = ref.isOpen, closeLoginDrawer = ref.closeElement;
    var ref1 = (0,router.useRouter)(), _query = ref1.query, goalUID = _query.goalUID, goalSlug = _query.goalSlug, pathname = ref1.pathname;
    (0,useLoginModalExperiment/* default */.Z)();
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)(goalUID);
    var ref2 = (0,useTopology/* default */.Z)(goalUID), storePurchaseData = ref2.topology;
    var pageName = constants/* GOAL_HOME */.d6;
    if (pathname.includes("subscriptions")) pageName = constants/* SUBSCRIPTION */.NK;
    else if (pathname.includes("success-story")) pageName = constants/* SUCCESS_STORY */.Tl;
    else if (pathname.includes("store")) pageName = constants/* STORE */.ud;
    var ref3 = (0,react.useState)(), currentTabIndex = ref3[0], setTabIndex = ref3[1];
    var ref4 = (0,react.useState)(pageMetaInfo === null || pageMetaInfo === void 0 ? void 0 : pageMetaInfo.showStoreTab), showStoreTab = ref4[0], setShowStoreTab = ref4[1];
    var seoContent = hooks_useSeoContent(segment/* FREE_HOME_PAGE */.tlK, goalUID).seoContent;
    var ref5 = (pageMetaInfo === null || pageMetaInfo === void 0 ? void 0 : pageMetaInfo.contentBlock) || (seoContent === null || seoContent === void 0 ? void 0 : seoContent.contentBlock) || {}, aboutSecTitle = ref5.title;
    var allTabs = (0,_to_consumable_array/* default */.Z)(constants/* HEADER_TABS */.K1);
    if (aboutSecTitle) {
        allTabs.push(constants/* ABOUT_TAB */.ch);
    }
    if (showStoreTab) {
        allTabs.splice(3, 0, constants/* STORE_TAB */.Y7);
    }
    var ref6 = (0,react.useState)(allTabs), headerTabs = ref6[0], setHeaderTabs = ref6[1];
    var ref7 = (0,useWindowSize/* default */.Z)(), isTablet = ref7.isTablet, isMobile = ref7.isMobile;
    var findTabByKey = function(key, value) {
        var tab = {};
        headerTabs.forEach(function(t, index) {
            if (t[key] === value) {
                tab = t;
                tab.index = index;
                return null;
            }
        });
        return tab;
    };
    var callback = function(entries) {
        entries.forEach(function(entry) {
            if (entry.intersectionRatio > 0.7) {
                var tab = findTabByKey("sectionId", entry.target.id);
                setTabIndex(tab.index);
            }
        });
    };
    (0,useFirstRenderSkip/* default */.Z)(function() {
        if ((storePurchaseData === null || storePurchaseData === void 0 ? void 0 : storePurchaseData.showStoreTab) === false) {
            setShowStoreTab(false);
        }
    }, [
        storePurchaseData === null || storePurchaseData === void 0 ? void 0 : storePurchaseData.showStoreTab
    ]);
    (0,react.useEffect)(function() {
        if (!showStoreTab) {
            var index = findTabByKey("id", constants/* TABSID.STORE */.NW.STORE).index;
            if (index > -1) {
                var tabs = (0,_to_consumable_array/* default */.Z)(headerTabs);
                tabs.splice(index, 1);
                setHeaderTabs(tabs);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showStoreTab
    ]);
    (0,react.useEffect)(function() {
        setTabIndex(findTabByKey("page", pageName).index);
        if (pageName === constants/* GOAL_HOME */.d6) {
            var options = {
                rootMargin: "0px",
                threshold: 0.7
            };
            setTimeout(function() {
                var observer = new IntersectionObserver(callback, options);
                headerTabs.forEach(function(tab) {
                    if (tab.sectionId) {
                        var section = document.getElementById(tab.sectionId);
                        if (section) observer.observe(section);
                    }
                });
            }, 5000);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageName,
        headerTabs.length
    ]);
    var handleOnChange = function(index, param) {
        var tabId = param.id;
        var selectedTab = findTabByKey("id", tabId);
        var section_name = selectedTab.sectionName;
        analytics/* segment.track */.EX.track(segment/* HOME_NAVIGATION_CLICKED */.wLb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
            last_primary_source_section: "Goal Home",
            last_primary_source: pageName,
            navigation_option: section_name
        }));
        setTabIndex(index);
        if (tabId === constants/* TABSID.SUCCESS_STORIES */.NW.SUCCESS_STORIES) {
            var route = {
                href: "/goal/[goalSlug]/[goalUID]/success-story",
                as: "/goal/".concat(goalSlug, "/").concat(goalUID, "/success-story")
            };
            (0,pushRoute/* default */.Z)(route.href, route.as);
        } else if (tabId === constants/* TABSID.SUBSCRIPTION_PLANS */.NW.SUBSCRIPTION_PLANS) {
            var route1 = {
                href: "/goal/[goalSlug]/[goalUID]/subscriptions",
                as: "/goal/".concat(goalSlug, "/").concat(goalUID, "/subscriptions")
            };
            (0,pushRoute/* default */.Z)(route1.href, route1.as);
        } else if (tabId === constants/* TABSID.STORE */.NW.STORE) {
            analytics/* segment.track */.EX.track(StoreListing_constants/* TAB_STORE_CLICKED */.oi, (0,_object_spread/* default */.Z)({}, goalSegmentData));
            var route2 = {
                href: "/goal/[goalSlug]/[goalUID]/store",
                as: "/goal/".concat(goalSlug, "/").concat(goalUID, "/store")
            };
            (0,pushRoute/* default */.Z)(route2.href, route2.as);
        } else if (pageName === constants/* GOAL_HOME */.d6) {
            var selectedSection = document.getElementById(selectedTab.sectionId);
            var headerHeight = document.querySelector("header").offsetHeight;
            if (selectedSection) {
                window.scrollTo({
                    top: selectedSection.offsetTop - headerHeight - 20,
                    left: 0,
                    behavior: "smooth"
                });
                window.location.hash = selectedTab.hash;
            }
        } else {
            var route3 = {
                href: "/goal/[goalSlug]/[goalUID]",
                as: "/goal/".concat(goalSlug, "/").concat(goalUID, "#").concat(selectedTab.hash)
            };
            (0,pushRoute/* default */.Z)(route3.href, route3.as);
        }
    };
    var onClose = (0,react.useCallback)(function() {
        closeLoginDrawer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var showStoreTooltip = Store_useStoreNudge({
        showStoreTab: showStoreTab
    }).showStoreTooltip;
    var isTabletOrMobile = isTablet || isMobile;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginComponent/* default */.Z, {
                drawerProps: {
                    drawerState: showLoginDrawer,
                    onClose: onClose
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewGoalHeader_HeaderContainer, {
                transparent: transparent,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewGoalHeader_HeaderParent, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoGoalSelectorWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoWrapper, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* default */.Z, {
                                            isReload: isReload,
                                            disabled: disabled,
                                            withoutText: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoalSelectorWrapper, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoalSelector, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RightContentWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchWrapper, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header_NewSearchTab, {})
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactUs, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReferralNudge_ReferralNudge, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginProfileWrapper, {
                                        children: isLoggedIn ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderUserContainer, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderUser["default"], {
                                                excludeOptions: [
                                                    "darkMode"
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RenderLoginAction/* default */.Z, {
                                            isJoinForFreeCtaExperiment: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScreenWrapper, {
                                        className: "desktop",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaymentNudge, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScreenWrapper, {
                        className: "mobile",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RenderTabs, {
                            currentTabIndex: currentTabIndex,
                            handleOnChange: handleOnChange,
                            headerTabs: headerTabs,
                            showStoreTooltip: isTabletOrMobile && showStoreTooltip
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabContainer, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabSubContainer, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScreenWrapper, {
                                className: "desktop",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RenderTabs, {
                                    currentTabIndex: currentTabIndex,
                                    handleOnChange: handleOnChange,
                                    headerTabs: headerTabs,
                                    showStoreTooltip: !isTabletOrMobile && showStoreTooltip
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
NewGoalHeader.defaultProps = {
    transparent: false,
    isReload: true,
    disabled: false
};
NewGoalHeader.propTypes = {
    transparent: (prop_types_default()).bool,
    isReload: (prop_types_default()).bool,
    disabled: (prop_types_default()).bool
};
/* harmony default export */ var Header_NewGoalHeader = (NewGoalHeader);

;// CONCATENATED MODULE: ./src/layout/NewGoalLayout/NewGoalLayout.jsx














var TTURenderer = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 37921).then(__webpack_require__.bind(__webpack_require__, 37921));
});
var NewGoalLayout_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "edxdoxq0",
    label: "Container"
})("--layout-width:1136px;--layout-tab-width:768px;--layout-mweb-width:328px;background-color:", function(param) {
    var $whiteBackground = param.$whiteBackground;
    return $whiteBackground ? "var(--color-base-1)" : "var(--color-base-0)";
}, ";");
var baseConfig = {
    mode: "light"
};
var NewGoalLayout = function(props) {
    var children = props.children, _layoutOptions = props.layoutOptions, layoutOptions = _layoutOptions === void 0 ? {} : _layoutOptions, pageMetaInfo = props.pageMetaInfo;
    var _ttuOptions = layoutOptions.ttuOptions, ttuOptions = _ttuOptions === void 0 ? {} : _ttuOptions, _hideIntercom = layoutOptions.hideIntercom, hideIntercom = _hideIntercom === void 0 ? false : _hideIntercom, _hideFooter = layoutOptions.hideFooter, hideFooter = _hideFooter === void 0 ? false : _hideFooter, _whiteBackground = layoutOptions.whiteBackground, whiteBackground = _whiteBackground === void 0 ? false : _whiteBackground;
    var query = (0,router.useRouter)().query;
    var currentGoalUID = query.goalUID;
    var insideApp = query.inside_app === "true" || false;
    var isMobile = (0,AppCommonData/* useIsMobile */.dD)();
    var ref = (0,react.useState)({
        value: false,
        fn: empty/* noOp */.EI
    }), backButton = ref[0], setBackButton = ref[1];
    var handleBackPress = function() {
        return backButton.fn();
    };
    var ttuShow = (0,ttu/* default */.Z)(ttuSelectors/* getTTUShow */.UX);
    var showTTUCurtain = (0,ttu/* default */.Z)(ttuSelectors/* getShowTTUCurtain */.qv);
    var ref1 = (0,react.useState)(ttuShow), showTTU = ref1[0], setShowTTU = ref1[1];
    var ref2 = (0,react.useState)(ttuOptions.openByDefault), showTTUTooltip = ref2[0], setShowTTUTooltip = ref2[1];
    var ref3 = (0,react.useState)("Scroll Trigger"), ttuTriggerSource = ref3[0], setTTUTriggerSource = ref3[1];
    var onCloseTTU = function() {
        setBackButton({
            value: false,
            fn: empty/* noOp */.EI
        });
        setShowTTU(false);
        showTTUCurtain(false);
        (0,fetchers_ttu/* showTTUOption */.U)(currentGoalUID);
    };
    (0,react.useEffect)(function() {
        setShowTTU(ttuShow);
    }, [
        ttuShow
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyleProvider/* default */.ZP, {
            config: baseConfig,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header_NewGoalHeader, {
                    pageMetaInfo: pageMetaInfo
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewGoalLayout_Container, {
                    $whiteBackground: whiteBackground,
                    children: children
                }),
                !insideApp && !hideFooter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewFooter/* default */.Z, {}),
                !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TTURenderer, {
                    onCloseTTU: onCloseTTU,
                    showTTU: showTTU,
                    backButton: backButton,
                    setBackButton: setBackButton,
                    handleBackPress: handleBackPress,
                    ttuTriggerSource: ttuTriggerSource,
                    ttuOptions: ttuOptions
                }),
                !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TTUWidgetRenderer["default"], {
                    showTTU: showTTU,
                    setShowTTU: setShowTTU,
                    showTTUTooltip: showTTUTooltip,
                    setShowTTUTooltip: setShowTTUTooltip,
                    ttuTriggerSource: ttuTriggerSource,
                    setTTUTriggerSource: setTTUTriggerSource,
                    hideIntercom: hideIntercom,
                    ttuOptions: ttuOptions
                })
            ]
        })
    });
};
/* harmony default export */ var NewGoalLayout_NewGoalLayout = (NewGoalLayout);


/***/ }),

/***/ 66583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _events_sendAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99691);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17579);
/* harmony import */ var _stores_selectors_ttuSelectors__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(29870);
/* harmony import */ var _stores_selectors_darkModeStatusSelectors__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(57054);
/* harmony import */ var _stores_useDarkModeStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3458);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2080);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87312);
/* harmony import */ var _base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28066);
/* harmony import */ var _base_H4_H4__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64250);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43135);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85620);
/* harmony import */ var _base_Button_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35415);
/* harmony import */ var _api_hooks_auth_useAccessControl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92890);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(73060);
/* harmony import */ var _stores_ttu__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94835);
/* harmony import */ var _icon_Call__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70376);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10076);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(87936);
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(59375);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_topology_useSelectedGoal__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(96487);
/* harmony import */ var _api_hooks_useGeoLocation__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(19304);
/* harmony import */ var _api_hooks_useConstants__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(79917);
/* harmony import */ var _api_selectors_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(17064);




























var Image = (0,_base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 80867));
});
var Close = (0,_base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 112));
});
var StyledH4 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_H4_H4__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    target: "e19xu9zu0",
    label: "StyledH4"
})("padding-right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_27B */ .t8.yz, ";");
var StyledP2 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e19xu9zu1",
    label: "StyledP2"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_2B */ .t8.Rw, ";color:var(--color-text-primary);font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Fonts.H6 */ .F3.H6, ";line-height:20px;padding-right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_30B */ .t8.hg, ";");
var StyledButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Button_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    target: "e19xu9zu2",
    label: "StyledButton"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_7B */ .t8.d5, ";");
var TTUIllustrationContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e19xu9zu3",
    label: "TTUIllustrationContainer"
})("position:absolute;height:108px;width:35%;right:0;top:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_6B */ .t8.BY, ";", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{height:100px;width:35%;bottom:0;}");
var TTUIllustration = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(Image, {
    target: "e19xu9zu4",
    label: "TTUIllustration"
})("height:100%;");
var TTUWidget = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e19xu9zu5",
    label: "TTUWidget"
})("background-color:var(--color-text-primary);width:64px;height:64px;position:fixed;bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_6B */ .t8.BY, ";right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_6B */ .t8.BY, ";border-radius:50%;display:flex;justify-content:center;align-items:center;cursor:pointer;z-index:300;", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{display:none;}");
var TTUToolTip = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e19xu9zu6",
    label: "TTUToolTip"
})("width:360px;height:", function(props) {
    return props.$isUs ? "306px" : "282px";
}, ";position:fixed;right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_6B */ .t8.BY, ";padding:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_6B */ .t8.BY, ";bottom:105px;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_2B */ .t8.Rw, ";background:linear-gradient(0deg,var(--color-base-1),var(--color-base-1));box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), ";");
var CallDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e19xu9zu7",
    label: "CallDiv"
})("display:flex;margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_7B */ .t8.d5, ";align-items:center;justify-content:center;");
var CallLabel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    target: "e19xu9zu8",
    label: "CallLabel"
})("font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Fonts.H7 */ .F3.H7, ";font-weight:700;line-height:150%;color:var(--color-text-secondary);");
var Phone = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("a", {
    target: "e19xu9zu9",
    label: "Phone"
})("display:flex;width:fit-content;margin-left:6px;");
function TTUWidgetRenderer(param) {
    var showTTUTooltip = param.showTTUTooltip, setShowTTUTooltip = param.setShowTTUTooltip, setShowTTU = param.setShowTTU, ttuTriggerSource = param.ttuTriggerSource, setTTUTriggerSource = param.setTTUTriggerSource, hideIntercom = param.hideIntercom, tmp = param.ttuOptions, ref = tmp === void 0 ? _constants_empty__WEBPACK_IMPORTED_MODULE_17__/* .emptyObject */ .FD : tmp, heading = ref.heading, overrideGoalEnabled = ref.overrideGoalEnabled, _eventProps = ref.eventProps, eventProps = _eventProps === void 0 ? _constants_empty__WEBPACK_IMPORTED_MODULE_17__/* .emptyObject */ .FD : _eventProps, _isOffline = ref.isOffline, isOffline = _isOffline === void 0 ? false : _isOffline;
    var me = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_23__/* .getMe */ .jo);
    var selectedGoal = (0,_api_hooks_topology_useSelectedGoal__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)().selectedGoal;
    var accessControl = (0,_api_hooks_auth_useAccessControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        goalUID: selectedGoal === null || selectedGoal === void 0 ? void 0 : selectedGoal.uid
    }).accessControl;
    var isPartner = (0,_api_selectors_auth__WEBPACK_IMPORTED_MODULE_23__/* .getIsPartner */ .Bd)(me, accessControl);
    var isRepeatUser = (0,_stores_ttu__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_stores_selectors_ttuSelectors__WEBPACK_IMPORTED_MODULE_24__/* .getIsRepeatUser */ .Ie);
    var ttuGoalEnabled = (0,_stores_ttu__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_stores_selectors_ttuSelectors__WEBPACK_IMPORTED_MODULE_24__/* .getTTUIsGoalEnabled */ .AP);
    var ttuShowData = (0,_stores_ttu__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_stores_selectors_ttuSelectors__WEBPACK_IMPORTED_MODULE_24__/* .getTTUShowData */ ._p);
    var ref1 = (0,_api_hooks_useGeoLocation__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(), tmp1 = ref1.geoLocationData, countryCode = (tmp1 === void 0 ? {} : tmp1).countryCode;
    var isEmailLoginFlow = (0,_api_hooks_useConstants__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_api_selectors_constants__WEBPACK_IMPORTED_MODULE_22__/* .isEmailLoginCountry */ .n2)(countryCode));
    var isDarkModeOn = (0,_stores_useDarkModeStatus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_stores_selectors_darkModeStatusSelectors__WEBPACK_IMPORTED_MODULE_25__/* .getIsDarkModeOn */ .q1);
    var onPhoneNumberClick = (0,react__WEBPACK_IMPORTED_MODULE_18__.useCallback)(function() {
        _actions_analytics__WEBPACK_IMPORTED_MODULE_16__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_2__/* .TTU_NUMBER_CLICKED */ .h4X, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({
            inbound_phone_number: _constants_index__WEBPACK_IMPORTED_MODULE_8__/* .inboundCallNumber */ .nI
        }, eventProps), _constants_index__WEBPACK_IMPORTED_MODULE_8__/* .evtNameCategoryMap.WITHOUT_CATEGORY */ .xK.WITHOUT_CATEGORY);
    }, [
        eventProps
    ]);
    if ((ttuGoalEnabled || overrideGoalEnabled) && (!(ttuShowData === null || ttuShowData === void 0 ? void 0 : ttuShowData.state) || (ttuShowData === null || ttuShowData === void 0 ? void 0 : ttuShowData.state) === 0) && !hideIntercom && !me.isEducator && !isPartner) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsxs */ .BX)(TTUWidget, {
            onClick: function() {
                if (!showTTUTooltip) {
                    (0,_events_sendAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .sendTTUEvents */ .cS)(_constants_segment__WEBPACK_IMPORTED_MODULE_2__/* .TTU_FAB_CLICK */ .OYd, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({
                        user_ttu_status: isRepeatUser ? "Repeat" : "New",
                        last_primary_source_section: "FAB icon"
                    }, eventProps), me.uid, me.username, selectedGoal.uid, selectedGoal.name);
                    setTTUTriggerSource("FAB icon");
                }
                setShowTTUTooltip(!showTTUTooltip);
            },
            children: [
                showTTUTooltip ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsx */ .tZ)(Close, {
                    color: "var(--color-base-0)",
                    size: "24px"
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsx */ .tZ)(Image, {
                    src: isDarkModeOn ? "ttu-dark.svg" : "ttu.svg",
                    height: 24,
                    width: 24,
                    alt: "ttu"
                }),
                showTTUTooltip && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsxs */ .BX)(TTUToolTip, {
                    $isUs: isEmailLoginFlow,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsx */ .tZ)(StyledH4, {
                            color: "var(--color-text-primary)",
                            children: heading || (isEmailLoginFlow ? "Have questions about the USMLE\xae Step 1 subscription?" : "Have questions about the subscription?")
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsx */ .tZ)(StyledP2, {
                            children: "Our expert can answer all your questions"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsx */ .tZ)(StyledButton, {
                            label: "Get a call from us",
                            color: "black",
                            grid: 5,
                            onClick: function() {
                                setShowTTUTooltip(false);
                                (0,_events_sendAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .sendTTUEvents */ .cS)(_constants_segment__WEBPACK_IMPORTED_MODULE_2__/* .TTU_POP_UP_CLICK */ .Oct, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({
                                    user_ttu_status: isRepeatUser ? "Repeat" : "New",
                                    last_primary_source: ttuTriggerSource,
                                    last_primary_source_section: ttuTriggerSource
                                }, eventProps), me.uid, me.username, selectedGoal.uid, selectedGoal.name);
                                if (selectedGoal.uid) {
                                    setShowTTU(true);
                                } else {
                                    window.open("/talktous?isOffline=".concat(isOffline), "_blank");
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsxs */ .BX)(CallDiv, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsx */ .tZ)(CallLabel, {
                                    children: "Or call us"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsxs */ .BX)(Phone, {
                                    href: "tel:".concat(_constants_index__WEBPACK_IMPORTED_MODULE_8__/* .inboundCallNumber */ .nI),
                                    onClick: onPhoneNumberClick,
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsx */ .tZ)(_icon_Call__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                            size: _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_5B */ .t8.zj,
                                            viewBox: "0 -4 24 24",
                                            color: "var(--color-text-primary)"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsx */ .tZ)(_base_H6_H6__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            children: _constants_index__WEBPACK_IMPORTED_MODULE_8__/* .inboundCallNumber */ .nI
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsx */ .tZ)(TTUIllustrationContainer, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_27__/* .jsx */ .tZ)(TTUIllustration, {
                                src: "ttu_illustration_new.svg",
                                layout: "fill"
                            })
                        })
                    ]
                })
            ]
        });
    }
    return null;
}
/* harmony default export */ __webpack_exports__["default"] = (TTUWidgetRenderer);


/***/ }),

/***/ 56046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ getTopicGroup; },
/* harmony export */   "Bc": function() { return /* binding */ isSummitClass; },
/* harmony export */   "PN": function() { return /* binding */ isCompleted; },
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "Zz": function() { return /* binding */ isUpcoming; },
/* harmony export */   "bc": function() { return /* binding */ getLinkPath; },
/* harmony export */   "fr": function() { return /* binding */ isOngoing; },
/* harmony export */   "k$": function() { return /* binding */ getInfoString; },
/* harmony export */   "mI": function() { return /* binding */ getDefaultThumbnail; }
/* harmony export */ });
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97428);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43135);
/* harmony import */ var _Item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46571);




var getInfoString = function(course) {
    var liveAt = course.liveAt || course.startsAt;
    if (!liveAt) return "";
    var infoString = "";
    if (course.state === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .courseStates.COMPLETED */ .MZ.COMPLETED) {
        infoString = "".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getDateShort */ .ZP.getDateShort(liveAt), " \u2022 ").concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getTimeFormatInShortFormWithoutSecs */ .ZP.getTimeFormatInShortFormWithoutSecs(course.lessonDuration));
    } else if (course.state === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .courseStates.LIVE */ .MZ.LIVE) {
        infoString = "Started on ".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].formatTime */ .ZP.formatTime(liveAt));
    }
    infoString = "Starts on ".concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getDateShort */ .ZP.getDateShort(liveAt), " \u2022 ").concat(_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* ["default"].formatTime */ .ZP.formatTime(liveAt));
    return infoString;
};
var isUpcoming = function(date) {
    if (!date) return false;
    var now = new Date();
    return new Date(date).getTime() > now.getTime();
};
var getDefaultThumbnail = function(course) {
    // To not show plus thumbnail if it's a free course
    if ((course.for_plus || course.forPlus) !== false && (course.programme_type || course.programmeType) === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES) {
        return "https://static.uacdn.net/thumbnail/course/testseries-placeholder.png";
    }
    return null;
};
var isOngoing = function(startsAt, endsAt) {
    if (!startsAt || !endsAt) return false;
    var now = new Date();
    return new Date(startsAt).getTime() < now.getTime() && new Date(endsAt).getTime() > now.getTime();
};
var isCompleted = function(date) {
    if (!date) return false;
    var now = new Date();
    return new Date(date).getTime() < now.getTime();
};
var isSummitClass = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return ((ref = data.goal) === null || ref === void 0 ? void 0 : ref.uid) === "DCGBT";
};
function courseModel(course) {
    var ref, ref1, ref2, ref3, ref4;
    var topicGroups = course.topic_groups || [
        course.topic_group
    ];
    var _state;
    var data = {
        uid: course.uid,
        name: course.name,
        isPartOfBatch: course.is_part_of_batch,
        thumbnail: course.cover_photo_v1 || course.thumbnail_v1 || course.thumbnail || course.cover_photo || getDefaultThumbnail(course),
        newThumbnail: course.cover_photo_v1,
        description: course.description || null,
        permalink: course.permalink,
        relativeLink: course.relative_link,
        averageRating: course.avg_rating,
        slug: course.slug,
        isActive: course.is_active,
        totalReviews: course.total_reviews,
        totalRatings: course.total_ratings,
        forPlus: course.for_plus || course.for_subscription,
        forSubscription: course.for_subscription,
        livestreamUrl: course.livestream_url,
        totalTime: course.total_time,
        totalSessionTime: course.total_session_time,
        viewCount: course.view_count,
        savedCount: course.saved_count,
        previewVideo: course.intro_video,
        language: (course === null || course === void 0 ? void 0 : course.language_display) || (course === null || course === void 0 ? void 0 : (ref = course.multiple_language_display) === null || ref === void 0 ? void 0 : ref[0]),
        liveClassCount: course.sessions_count,
        isEnrolled: course.is_enrolled,
        isBookmarked: course.bookmarked,
        isSpecial: course.is_special,
        isIconic: course.is_iconic,
        enrollmentCount: course.enrollment_count,
        secondaryType: course.secondary_type,
        courseType: course.programme_type,
        isLive: course.is_live,
        state: (_state = course.state) !== null && _state !== void 0 ? _state : course.status,
        liveClassesRemaining: course.sessions_remaining,
        itemCount: course.all_item_count || course.item_count,
        lessonsWatched: course.lessons_watched,
        lessonsCompleted: course.lessons_completed,
        startsAt: course.starts_at,
        endsAt: course.ends_at,
        isUpcoming: isUpcoming(course.starts_at),
        isOngoing: isOngoing(course.starts_at, course.ends_at),
        isCompleted: course.is_completed || isCompleted(course.ends_at),
        quizCount: course.all_item_count - course.sessions_count,
        channelDetails: course.channel,
        nextTrack: {
            item: course.next_track || course.next_session || course.next_class || course.next_item
        },
        previousTrack: {
            item: course.previous_session
        },
        authors: course.authors ? course.authors.map(function(author) {
            return {
                user: author
            };
        }) : [
            {
                user: course.author
            }
        ],
        topicGroups: topicGroups ? topicGroups.map(function(topicGroup) {
            return {
                topology: topicGroup
            };
        }) : null,
        topic: course === null || course === void 0 ? void 0 : (ref1 = course.topic_groups) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name,
        conceptTopology: course === null || course === void 0 ? void 0 : (ref3 = course.concept_topology) === null || ref3 === void 0 ? void 0 : ref3.name,
        coverPhoto: course.cover_photo_v1 || course.cover_photo || course.thumbnail || getDefaultThumbnail(course),
        colorCode: course.color_code,
        goal: course.goal ? {
            topology: course.goal
        } : null,
        topologies: course.topologies ? course.topologies.map(function(topologyItem) {
            return {
                topology: topologyItem
            };
        }) : null,
        goalUid: course.goal_uid || ((ref4 = course.goal) === null || ref4 === void 0 ? void 0 : ref4.uid) || null,
        liveClasses: course.live_classes ? course.live_classes.map(function(itemData) {
            return {
                item: itemData
            };
        }) : null,
        tag: course.tag,
        unLiveUrl: course.unlive_url,
        progress: course.progress,
        conceptLessonCount: course.lesson_count,
        ogImage: course.og_image || null,
        type: course.type || "",
        voiceLanguages: course.voiceLanguages,
        contentSlideLanguages: course.contentSlideLanguages,
        batchGroup: course.batch_group || null,
        totalDPPCount: (course === null || course === void 0 ? void 0 : course.total_practice_dpp_count) || 0,
        queryID: course.queryID,
        requestID: course.requestID,
        index: course.index,
        isRecordedClassesOnlyCourse: !course.is_live_class_present
    };
    if (course.progress) {
        data.progress.nextLessonRelativeLink = course.progress.next_lesson_relative_link;
        data.progress.isCompleted = parseInt(course.progress.percentage, 2) === 100;
    }
    if (course.programme) {
        data.isRecordedClassesOnlyCourse = !course.programme.is_live_class_present;
    }
    data.infoString = getInfoString(data);
    return data;
}
function getEntityData(data) {
    return courseModel(data);
}
var getTopicGroup = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data.topicGroups ? data.topicGroups[0] : null;
};
var getAuthorsName = function(authors) {
    if (!authors) return "";
    var nameText = authors.slice(0, 3).reduce(function(initial, educator, index) {
        if (index === 1) return initial + educator.name;
        if (index < 2 && authors.length === 1) return initial + educator.name;
        if (index < 2) return "".concat(initial, " ").concat(educator.name, ", ");
        return "".concat(initial, " and ").concat(authors.length - 2, " more");
    }, "");
    return nameText;
};
var getLinkPath = function(data) {
    // if course is special
    if (data.isSpecial || data.showAsLesson) {
        var ref, ref1;
        // if a course is special class and inside properties of nextTrack/nextSession uid and relativeLink is available then use class link instead of course link to save redirect from course to class
        var nextTrack = data.nextTrack;
        if (nextTrack && ((nextTrack === null || nextTrack === void 0 ? void 0 : nextTrack.uid) || (nextTrack === null || nextTrack === void 0 ? void 0 : (ref = nextTrack.properties) === null || ref === void 0 ? void 0 : ref.uid) && (nextTrack === null || nextTrack === void 0 ? void 0 : (ref1 = nextTrack.properties) === null || ref1 === void 0 ? void 0 : ref1.relativeLink))) {
            return "/class/[slug]/[uid]";
        }
        return "/course/[slug]/[courseUID]";
    }
    var type = data.type, forPlus = data.forPlus, courseType = data.courseType;
    // lesson - Free course
    if (!forPlus && data.progress && !data.progress.isCompleted && data.progress.nextLessonRelativeLink) {
        return "/lesson/[lessonSlug]/[lessonUID]";
    }
    // checking whether the passed object is course or item. (item)
    if (type === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .itemTypes.POST */ .cs.POST) {
        // if item and plus item means a class
        if (forPlus) return "/class/[slug]/[uid]";
        return "/lesson/[lessonSlug]/[lessonUID]";
    }
    if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES || courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.HYBRID_TESTSERIES */ .h7.HYBRID_TESTSERIES) {
        return "/test-series/[slug]/[courseUID]/";
    }
    return "/course/[slug]/[courseUID]/";
};
var getLink = function(data) {
    if (data.isSpecial || data.showAsLesson) return (0,_Item__WEBPACK_IMPORTED_MODULE_3__/* .getLink */ .Rg)(data);
    if (!data.forPlus && data.progress && !data.progress.isCompleted && data.progress.nextLessonRelativeLink) {
        return data.progress.nextLessonRelativeLink;
    }
    var slug = data.slug;
    var type = data.type, forPlus = data.forPlus, courseType = data.courseType;
    if (!slug) {
        var ref;
        var courseName = (ref = data.name) === null || ref === void 0 ? void 0 : ref.replace(/\/|\\/g, " ");
        slug = _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getStringWordsJoinedWith */ .ZP.getStringWordsJoinedWith(courseName, "-");
    }
    if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES || courseType === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .programmeTypes.HYBRID_TESTSERIES */ .h7.HYBRID_TESTSERIES) {
        return "/test-series/".concat(slug, "/").concat(data.uid);
    }
    return "/".concat(type === _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .itemTypes.POST */ .cs.POST ? forPlus && "class" || "lesson" : "course", "/").concat(slug, "/").concat(data.uid);
};
var course = {
    Course: courseModel,
    getEntityData: getEntityData,
    getAuthorsName: getAuthorsName,
    getTopicGroup: getTopicGroup,
    getLink: getLink,
    getLinkPath: getLinkPath,
    isSummitClass: isSummitClass
};
/* harmony default export */ __webpack_exports__["ZP"] = (course);


/***/ }),

/***/ 34482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ getTopicLinkHref; },
/* harmony export */   "EN": function() { return /* binding */ getSpecialClassesLinkHref; },
/* harmony export */   "Ho": function() { return /* binding */ getHrefAndAsOfAFreeCourse; },
/* harmony export */   "Hw": function() { return /* binding */ getLinkHref; },
/* harmony export */   "Lb": function() { return /* binding */ getSpecialClassesLink; },
/* harmony export */   "Po": function() { return /* binding */ getSpecialClassesAllLink; },
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "TW": function() { return /* binding */ getCoursesHref; },
/* harmony export */   "UP": function() { return /* binding */ getBrowseLink; },
/* harmony export */   "_Y": function() { return /* binding */ getYoutubeLessonLink; },
/* harmony export */   "b4": function() { return /* binding */ getCoursesAsPath; },
/* harmony export */   "bU": function() { return /* binding */ getYoutubeCourseLink; },
/* harmony export */   "bc": function() { return /* binding */ getLinkPath; },
/* harmony export */   "dF": function() { return /* binding */ getTopicListLink; },
/* harmony export */   "dL": function() { return /* binding */ getEntityData; },
/* harmony export */   "pA": function() { return /* binding */ getTopicLink; },
/* harmony export */   "s3": function() { return /* binding */ getTopicListHref; },
/* harmony export */   "v9": function() { return /* binding */ getGtpFreeClassesAllLink; },
/* harmony export */   "vX": function() { return /* binding */ getHrefAndAsOfSaved; },
/* harmony export */   "vx": function() { return /* binding */ getPannerLink; },
/* harmony export */   "yb": function() { return /* binding */ getTopologyName; }
/* harmony export */ });
/* unused harmony exports topologyModal, getBrowseLinkAs, getBrowseLinkHref, getPlannerLinkAs, plannerLink */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);



function topologyModal(topology) {
    var ref;
    // window map
    // "today": 0,
    // "tomorrow": 1,
    // "this week": 2,
    // "in 15 days": 3,
    // "yesterday": -1,
    // "last week": -2,
    // "15 days ago": -3,
    return {
        uid: topology.uid,
        name: topology.name,
        permalink: topology.permalink,
        relativeLink: topology.relative_link,
        goalSlug: topology.slug,
        title: topology.title,
        coursesCount: topology.courses_count || topology.item_count || topology.count || topology.plus_course_count || topology.course_count || 0,
        upcomingCoursesCount: topology.upcoming_count || 0,
        upcomingCoursesThisMonth: topology.upcoming_this_month || 0,
        enrolledCoursesCount: topology.enrolled_count || 0,
        totalSubItem: topology.total_subItem || 0,
        progress: topology.progress || 0,
        color: topology.color,
        plusCourseCount: topology.plusCourseCount || topology.total_count || 0,
        colorCode: topology.color_code,
        level: topology.level,
        fullName: topology.title,
        icon: topology.icon,
        children: topology.children,
        slug: topology.slug || (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .getStringWordsJoinedWith */ .kL)(topology.name, "-"),
        parent: topology.parent,
        isPracticeAvailable: topology.is_practice_session,
        isPlusAvailable: topology.is_plus_available,
        isFreeUnavailable: topology.is_free_unavailable,
        language: topology.language || null,
        ogImage: topology.og_image || null,
        window: topology.window,
        windowCount: topology.window_count,
        selfDataFetched: topology.selfDataFetched || false,
        tags: topology.tags,
        isNoTestGoal: !!((ref = topology.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return (tag === null || tag === void 0 ? void 0 : tag.name) === "NON_TEST_PREP";
        })),
        isIconicAvailable: topology.is_iconic_available,
        externalApps: topology.external_apps_available,
        isSyllabusV1Enabled: topology.is_syllabus_v1_enabled,
        isPlatformGoal: topology.is_platform_goal || false,
        goalLevelOnboarding: {
            isAvailable: topology.is_goal_onboarding_available || false,
            status: topology.user_onboarding_status || null,
            hideNudge: false
        },
        isLeaderdboardMetaInfoAvailable: topology.is_leaderdboard_meta_info_available,
        leaderboardFilters: topology.leaderboard_filters,
        leaderboardScreenMetaInfo: topology.leaderboard_screen_meta_info,
        isCatalogueFeatureAvailable: topology.is_catalogue_feature_available || false,
        isK12: topology.is_k12_goal || false,
        isUaIconGoal: topology.is_ua_icon_goal || false,
        isRecordedGoal: topology.is_recorded_goal,
        isCentreAvailable: topology.is_centre_available
    };
}
function getEntityData(data) {
    return topologyModal(data);
}
var getLink = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid);
};
var getBrowseLinkAs = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid, "/browse");
};
var getBrowseLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]/browse";
};
var getBrowseLink = function(data) {
    return {
        as: getBrowseLinkAs(data),
        href: getBrowseLinkHref()
    };
};
var getPlannerLinkAs = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid, "/planner");
};
var plannerLink = "/goal/[goalSlug]/[goalUID]/planner";
var getPannerLink = function(data) {
    return {
        as: getPlannerLinkAs(data),
        href: plannerLink
    };
};
/**
 * Retuns link href of a generic goal
 * @returns string pattern of a generic goal href
 */ var getLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]";
};
var getTopicLink = function(topic, goal) {
    return "/goal/".concat(goal.slug, "/").concat(goal.uid, "/topic/").concat(topic.uid);
};
var getTopicLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]/topic/[topicUid]";
};
var getTopicListLink = function(goal) {
    return "/goal/".concat(goal.slug, "/").concat(goal.uid, "/topics");
};
var getTopicListHref = function() {
    return "/goal/goalSlug/goalUID/topics";
};
var getLinkPath = function() {
    return "/goal/[goalSlug]/[goalUID]/topic/[topicUid]";
};
var getSpecialClassesLink = function(data) {
    return "".concat(getLink(data), "/classes");
};
var getSpecialClassesLinkHref = function() {
    return "".concat(getLinkHref(), "/classes");
};
var getSpecialClassesAllLink = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/classes",
        as: "".concat(getLink(data), "/classes")
    };
};
var getGtpFreeClassesAllLink = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/classes/[type]",
        as: "".concat(getLink(data), "/classes/all_classes")
    };
};
var getYoutubeCourseLink = function(data) {
    return {
        href: "/content/p/freecourses/[goalUID]",
        as: "/content/p/freecourses/".concat(data.goalUID)
    };
};
var getYoutubeLessonLink = function(data) {
    return {
        href: "/content/p/freecourses/[goalUID]/[courseTitle]/[courseUID]/[lessonUID]",
        as: "/content/p/freecourses/".concat(data.goalUID, "/").concat(data.courseTitle, "/").concat(data.courseUID, "/").concat(data.lessonUID)
    };
};
var getHrefAndAsOfAFreeCourse = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/free-platform",
        as: "".concat(getLink(data), "/free-platform")
    };
};
var getHrefAndAsOfSaved = function(goal) {
    return {
        href: "".concat(getLinkHref(), "/saved"),
        as: "".concat(getLink(goal), "/saved")
    };
};
var getCoursesHref = function() {
    return "".concat(getTopicLinkHref(), "/courses");
};
var getCoursesAsPath = function(goalSlug, goalUID, topicUID) {
    return "".concat(getTopicLink({
        uid: topicUID
    }, {
        slug: goalSlug,
        uid: goalUID
    }), "/courses");
};
var _obj;
var getTopologyName = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.CATEGORY */ .OP.CATEGORY, "Category"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.GOAL */ .OP.GOAL, "Goal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.GROUP */ .OP.GROUP, "Topic Group"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.TOPIC */ .OP.TOPIC, "Topic"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.CONCEPT */ .OP.CONCEPT, "Concept"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.SUBCONCEPT */ .OP.SUBCONCEPT, "Subconcept"), _obj);
var topology = {
    Topology: topologyModal,
    getEntityData: getEntityData,
    getLink: getLink,
    getLinkHref: getLinkHref,
    getSpecialClassesLink: getSpecialClassesLink,
    getLinkPath: getLinkPath,
    getTopicLink: getTopicLink,
    getTopicListLink: getTopicListLink,
    getSpecialClassesAllLink: getSpecialClassesAllLink,
    getHrefAndAsOfAFreeCourse: getHrefAndAsOfAFreeCourse,
    getTopicListHref: getTopicListHref,
    getSpecialClassesLinkHref: getSpecialClassesLinkHref,
    getTopicLinkHref: getTopicLinkHref,
    getHrefAndAsOfSaved: getHrefAndAsOfSaved,
    getTopologyName: getTopologyName
};
/* harmony default export */ __webpack_exports__["ZP"] = (topology);


/***/ }),

/***/ 81570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HQ": function() { return /* binding */ isLegendEducator; },
/* harmony export */   "Pp": function() { return /* binding */ getFullName; },
/* harmony export */   "dL": function() { return /* binding */ getEntityData; },
/* harmony export */   "ug": function() { return /* binding */ formatFirstName; }
/* harmony export */ });
/* unused harmony export getRelativeLink */
/* harmony import */ var _utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21848);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);


var formatFirstName = function(firstName) {
    return firstName ? firstName.toLocaleString() : "";
};
var getRelativeLink = function(user) {
    var url = "/learner/@".concat(user.username);
    if (user.is_educator || user.is_moderator) url = user.relative_link || "/@".concat(user.username);
    return url;
};
var getFullName = function(firstName, lastName) {
    return "".concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(firstName), " ").concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(lastName));
};
function userModel(userData) {
    var user = userData.author_details ? userData.author_details : userData;
    var firstName = user.first_name ? user.first_name.toLocaleString() : "";
    var lastName = user.last_name ? user.last_name : "";
    return {
        firstName: firstName,
        lastName: lastName,
        uid: user.uid,
        isFullStoryUser: user.is_full_story_user,
        name: getFullName(firstName, lastName),
        thumbnail: user.avatar_v1 || user.avatar || null,
        description: user.bio || null,
        permalink: user.permalink,
        relativeLink: getRelativeLink(user),
        averageRating: user.avg_rating,
        username: user.username.toLowerCase() || null,
        referralInfo: user.referral_info,
        followersCount: user.followers_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.followers_count) : null,
        followingCount: user.follows_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.follows_count) : null,
        lifetimeViews: user.lifetime_views ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.lifetime_views) : null,
        starRatings: user.star_ratings ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.star_ratings) : null,
        isFollowing: user.is_following,
        postsCount: user.posts_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.posts_count) : null,
        coursesCount: user.courses_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.courses_count) : null,
        isEducator: user.is_educator,
        isModerator: user.is_moderator,
        isVerifiedEducator: user.is_verified_educator,
        isExEducator: user.is_ex_educator,
        isEmailVerified: user.is_email_verified,
        isPhoneVerified: user.is_phone_verified,
        isProfileFilled: user.is_profile_filled,
        isPlatformEducator: user.is_platform_educator,
        isPlatinumEducator: user.is_platinum_educator,
        dedications: user.dedications,
        topicsDisplay: user.topics_display,
        stats: user.stats,
        phone: user.phone,
        email: user.email,
        state: user.state,
        country: user.country,
        language: user.language,
        canAddPlusCourse: user.can_add_plus_course,
        canAddSpecialClass: user.can_add_special_class,
        verifiedEducatorAt: user.verified_educator_at,
        liveMinutes: user.live_minutes ? Math.round(user.live_minutes / 60) : 0,
        totalWatchMins: user.total_watch_time ? Math.round(user.total_watch_time / 60) : 0,
        credentials: user.credentials,
        languages: user.languages,
        becomeEducatorAt: user.become_educator_at,
        educatorType: user.educator_type,
        educatorTypeV2: user.educator_type_v2,
        knowsAbout: user.knows_about,
        levelInfo: user.level_info || {},
        levelId: user.level_id,
        dateJoined: user.date_joined,
        ogImage: user.og_image || null,
        leaderboardMetaInfo: user.leaderboard_meta_info || null,
        avatarV1: user.avatar_v1 || null,
        avatarV2: user.avatar_v2 || null,
        oldAvatar: user.old_avatar || null,
        fallbackAvatar: user.avatar || null,
        queryID: user.queryID,
        requestID: user.requestID,
        index: user.index
    };
}
function getEntityData(data) {
    return userModel(data);
}
var isLegendEducator = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data.uid === "WO7LDJ3Y2Z" || data.educatorType === 4;
};
var user = {
    User: userModel,
    getEntityData: getEntityData,
    isLegendEducator: isLegendEducator
};
/* harmony default export */ __webpack_exports__["ZP"] = (user);


/***/ }),

/***/ 75982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gp": function() { return /* binding */ isScheduleDataForDppFetched; },
/* harmony export */   "nB": function() { return /* binding */ getPreviewMode; }
/* harmony export */ });
/* unused harmony exports getSnackBarContent, getSubscriptionFeatures, getSubscriptionHighlights, getIconicFAQs */
var getSnackBarContent = function(param) {
    var others = param.others;
    return others.snackBarContent;
};
var getPreviewMode = function(param) {
    var others = param.others;
    return others.nextPreviewMode || false;
};
var isScheduleDataForDppFetched = function(param) {
    var others = param.others;
    return others === null || others === void 0 ? void 0 : others.isScheduleDataForDppFetched;
};
var getSubscriptionFeatures = function(param) {
    var others = param.others;
    return others.subscriptionFeatures;
};
var getSubscriptionHighlights = function(param) {
    var others = param.others;
    return others.subscriptionHighlights;
};
var getIconicFAQs = function(param) {
    var others = param.others;
    return others.iconicFAQs;
};


/***/ }),

/***/ 27961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* harmony import */ var _utils_createStoreSelector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83909);




var useStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return {
        isPaymentNudge: true,
        setPaymentNudge: function(value) {
            set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    isPaymentNudge: value
                });
            });
        }
    };
});
var usePaymentNudgeStore = (0,_utils_createStoreSelector__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(useStore);
/* harmony default export */ __webpack_exports__["Z"] = (usePaymentNudgeStore);


/***/ }),

/***/ 44545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loginStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/api/fetchers/config.js
var config = __webpack_require__(8989);
// EXTERNAL MODULE: ./src/api/fetchers/index.js
var fetchers = __webpack_require__(19982);
;// CONCATENATED MODULE: ./src/api/fetchers/login/index.js
/* eslint-disable import/prefer-default-export */ 

var login = function(param) {
    var email = param.email, phone = param.phone, otp = param.otp, countryCode = param.countryCode, backend = param.backend, firstName = param.firstName, lastName = param.lastName, state = param.state, password = param.password, register = param.register, _forClassroom = param.forClassroom, forClassroom = _forClassroom === void 0 ? false : _forClassroom, _code = param.code, code = _code === void 0 ? "" : _code, _ageGroupID = param.ageGroupID, ageGroupID = _ageGroupID === void 0 ? "" : _ageGroupID, accessToken = param.accessToken;
    return (0,fetchers/* default */.Z)("v1/user/login/?enable-email=true", {
        requestType: "POST",
        useAuthToken: false,
        useCamelCase: false,
        body: {
            backend: backend,
            phone: phone,
            otp: otp,
            access_token: accessToken,
            client_id: config/* default.apiClientId */.Z.apiClientId,
            client_secret: config/* default.apiClientSecret */.Z.apiClientSecret,
            country_code: countryCode,
            email: email,
            first_name: firstName,
            last_name: lastName,
            state: state,
            password: password,
            register: register,
            user_info: false,
            is_un_teach_user: forClassroom,
            un_teach_institue_code: code,
            country_age_group_uid: ageGroupID
        }
    });
};
var sendOtpOrEmail = function(param) {
    var _phone = param.phone, phone = _phone === void 0 ? "" : _phone, countryCode = param.countryCode, otpType = param.otpType, _email = param.email, email = _email === void 0 ? "" : _email, _forClassroom = param.forClassroom, forClassroom = _forClassroom === void 0 ? false : _forClassroom;
    return (0,fetchers/* default */.Z)("v3/user/user_check/?enable-email=true", {
        requestType: "POST",
        useAuthToken: false,
        useCamelCase: false,
        body: {
            phone: phone,
            country_code: countryCode,
            otp_type: otpType,
            email: email,
            send_otp: true,
            is_un_teach_user: forClassroom
        }
    });
};
var verifyPhone = function(param) {
    var phone = param.phone, countryCode = param.countryCode, otpType = param.otpType;
    return (0,fetchers/* default */.Z)("v1/user/me/verify_phone_otp/", {
        requestType: "POST",
        useCamelCase: false,
        body: {
            phone: phone,
            country_code: countryCode,
            otp_type: otpType
        }
    });
};

;// CONCATENATED MODULE: ./src/stores/login/loginStore.js




var useLoginStore = (0,esm/* default */.Z)(function(set) {
    return {
        initialAccountType: null,
        loggingIn: false,
        isSendingOtp: false,
        otpOrEmailData: null,
        loginResponse: null,
        verifyOtpResponse: {
            type: "phone",
            submitting: false,
            success: false,
            error: false,
            errorMsg: ""
        },
        isNewLoginModal: false,
        IsLoginModalExperiment: false,
        isLoginModalVariation: null,
        login: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
                var loginResponse;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                loggingIn: true
                            });
                            _ctx.next = 3;
                            return login(body);
                        case 3:
                            loginResponse = _ctx.sent;
                            set({
                                loginResponse: loginResponse,
                                loggingIn: false
                            });
                            return _ctx.abrupt("return", loginResponse);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(body) {
                return _ref.apply(this, arguments);
            };
        }(),
        sendOtpOrEmail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
                var otpOrEmailData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isSendingOtp: true
                            });
                            _ctx.next = 3;
                            return sendOtpOrEmail(body);
                        case 3:
                            otpOrEmailData = _ctx.sent;
                            set({
                                otpOrEmailData: otpOrEmailData,
                                isSendingOtp: false
                            });
                            return _ctx.abrupt("return", otpOrEmailData);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(body) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetOtpResponse: function() {
            return set({
                otpOrEmailData: null
            });
        },
        verifyPhone: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
                var ref, verifyOtpResponse;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            set({
                                verifyOtpResponse: {
                                    type: "phone",
                                    submitting: true,
                                    success: false,
                                    error: false,
                                    errorMsg: ""
                                }
                            });
                            _ctx.next = 4;
                            return verifyPhone(body);
                        case 4:
                            verifyOtpResponse = _ctx.sent;
                            set({
                                verifyOtpResponse: {
                                    type: "phone",
                                    submitting: false,
                                    success: !(verifyOtpResponse === null || verifyOtpResponse === void 0 ? void 0 : verifyOtpResponse.error),
                                    error: !!(verifyOtpResponse === null || verifyOtpResponse === void 0 ? void 0 : verifyOtpResponse.error),
                                    errorMsg: (verifyOtpResponse === null || verifyOtpResponse === void 0 ? void 0 : (ref = verifyOtpResponse.error) === null || ref === void 0 ? void 0 : ref.message) || ""
                                }
                            });
                            return _ctx.abrupt("return", verifyOtpResponse);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(body) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetVerifyOtpResponse: function() {
            return set({
                verifyOtpResponse: null
            });
        },
        setLocalPhoneNumber: function(localPhoneNumber, localSelectedCountry) {
            return set({
                localPhoneNumber: localPhoneNumber,
                localSelectedCountry: localSelectedCountry
            });
        },
        setLocalEmailAndName: function(localEmail, localName) {
            return set({
                localEmail: localEmail,
                localName: localName
            });
        },
        setInitialAccountType: function(initialAccountType) {
            return set({
                initialAccountType: initialAccountType
            });
        },
        setIsNewLoginModal: function(isNewLoginModal) {
            return set({
                isNewLoginModal: isNewLoginModal
            });
        },
        setIsLoggingIn: function(loggingIn) {
            return set({
                loggingIn: loggingIn
            });
        },
        setIsLoginModalExperiment: function(IsLoginModalExperiment) {
            return set({
                IsLoginModalExperiment: IsLoginModalExperiment
            });
        },
        setIsLoginModalVariation: function(isLoginModalVariation) {
            return set({
                isLoginModalVariation: isLoginModalVariation
            });
        }
    };
});
/* harmony default export */ var loginStore = (useLoginStore);


/***/ }),

/***/ 98964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ getOtpOrEmailResponse; },
/* harmony export */   "$Q": function() { return /* binding */ getLocalName; },
/* harmony export */   "BD": function() { return /* binding */ getInitialAccountType; },
/* harmony export */   "Bt": function() { return /* binding */ getSetLocalPhoneNumber; },
/* harmony export */   "Ep": function() { return /* binding */ getIsPartialUser; },
/* harmony export */   "FQ": function() { return /* binding */ getLoginResponse; },
/* harmony export */   "IX": function() { return /* binding */ getSetInitialAccountType; },
/* harmony export */   "L": function() { return /* binding */ getIsLoggingIn; },
/* harmony export */   "Rw": function() { return /* binding */ getSetIsLoginModalVariation; },
/* harmony export */   "SE": function() { return /* binding */ getOTPSender; },
/* harmony export */   "Tj": function() { return /* binding */ getResetVerifyOtpResponse; },
/* harmony export */   "W4": function() { return /* binding */ getLocalPhoneNumber; },
/* harmony export */   "Yk": function() { return /* binding */ getSetLocalEmailAndName; },
/* harmony export */   "al": function() { return /* binding */ getIsLoginModalExperiment; },
/* harmony export */   "aw": function() { return /* binding */ getIsPhoneVerified; },
/* harmony export */   "bq": function() { return /* binding */ getLocalSelectedCountry; },
/* harmony export */   "eG": function() { return /* binding */ getIsRegistered; },
/* harmony export */   "gB": function() { return /* binding */ getPhoneVerifier; },
/* harmony export */   "jC": function() { return /* binding */ getLoginMethod; },
/* harmony export */   "k$": function() { return /* binding */ getLocalEmail; },
/* harmony export */   "lf": function() { return /* binding */ getSetIsLoginModalExperiment; },
/* harmony export */   "pK": function() { return /* binding */ getLoginAction; },
/* harmony export */   "qN": function() { return /* binding */ getSetIsNewLoginModal; },
/* harmony export */   "qw": function() { return /* binding */ getIsSendingOtp; },
/* harmony export */   "w8": function() { return /* binding */ getSetIsLoggingIn; },
/* harmony export */   "wM": function() { return /* binding */ getOTPDataCleaner; },
/* harmony export */   "wm": function() { return /* binding */ getIsLoginModalVariation; },
/* harmony export */   "zf": function() { return /* binding */ getIsNewLoginModal; }
/* harmony export */ });
var getLoginResponse = function(auth) {
    return auth.loginResponse;
};
var getIsLoggingIn = function(auth) {
    return auth.loggingIn;
};
var getIsSendingOtp = function(auth) {
    return auth.isSendingOtp;
};
var ref;
var getLoginMethod = function(auth) {
    var ref1;
    return (ref = (ref1 = auth.otpOrEmailData) === null || ref1 === void 0 ? void 0 : ref1.login_method) !== null && ref !== void 0 ? ref : false;
};
var getOtpOrEmailResponse = function(auth) {
    return auth.otpOrEmailData;
};
var ref1;
var getIsRegistered = function(auth) {
    var ref;
    return (ref1 = (ref = auth.otpOrEmailData) === null || ref === void 0 ? void 0 : ref.is_registered) !== null && ref1 !== void 0 ? ref1 : false;
};
var getIsPartialUser = function(auth) {
    var ref;
    var ref1 = (auth === null || auth === void 0 ? void 0 : auth.otpOrEmailData) || {}, is_email_verified = ref1.is_email_verified, is_registered = ref1.is_registered, has_name = ref1.has_name;
    if (is_registered && (is_email_verified || has_name)) return false;
    var ref2;
    return (ref2 = (ref = auth.otpOrEmailData) === null || ref === void 0 ? void 0 : ref.is_partial_user) !== null && ref2 !== void 0 ? ref2 : false;
};
var ref2;
var getIsPhoneVerified = function(auth) {
    var ref;
    return (ref2 = (ref = auth.otpOrEmailData) === null || ref === void 0 ? void 0 : ref.verify_phone) !== null && ref2 !== void 0 ? ref2 : false;
};
var getLocalPhoneNumber = function(auth) {
    return auth.localPhoneNumber;
};
var getLocalSelectedCountry = function(auth) {
    return auth.localSelectedCountry;
};
var getLocalEmail = function(auth) {
    return auth.localEmail;
};
var getLocalName = function(auth) {
    return auth.localName;
};
var getInitialAccountType = function(auth) {
    return auth.initialAccountType;
};
var getIsNewLoginModal = function(auth) {
    return auth.isNewLoginModal;
};
var getIsLoginModalExperiment = function(auth) {
    return auth.IsLoginModalExperiment;
};
var getIsLoginModalVariation = function(auth) {
    return auth.isLoginModalVariation;
};
// Setters and actions
var getLoginAction = function(auth) {
    return auth.login;
};
var getOTPSender = function(auth) {
    return auth.sendOtpOrEmail;
};
var getOTPDataCleaner = function(auth) {
    return auth.resetOtpResponse;
};
var getPhoneVerifier = function(auth) {
    return auth.verifyPhone;
};
var getResetVerifyOtpResponse = function(auth) {
    return auth.resetVerifyOtpResponse;
};
var getSetLocalPhoneNumber = function(auth) {
    return auth.setLocalPhoneNumber;
};
var getSetLocalEmailAndName = function(auth) {
    return auth.setLocalEmailAndName;
};
var getSetInitialAccountType = function(auth) {
    return auth.setInitialAccountType;
};
var getSetIsNewLoginModal = function(auth) {
    return auth.setIsNewLoginModal;
};
var getSetIsLoggingIn = function(auth) {
    return auth.setIsLoggingIn;
};
var getSetIsLoginModalExperiment = function(auth) {
    return auth.setIsLoginModalExperiment;
};
var getSetIsLoginModalVariation = function(auth) {
    return auth.setIsLoginModalVariation;
};


/***/ }),

/***/ 83909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60374);

// Selector ref: https://github.com/pmndrs/zustand/wiki/Auto-Generating-Selectors
// Shallow store ref: https://github.com/pmndrs/zustand#selecting-multiple-state-slices
// To get the property/action: const propertyName = useStore.use.propertyName()
function createStoreSelectors(store) {
    store.use = {};
    Object.keys(store.getState()).forEach(function(key) {
        var selector = function(state) {
            return state[key];
        };
        store.use[key] = function() {
            return store(selector, zustand_shallow__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
        };
    });
    return store;
}
/* harmony default export */ __webpack_exports__["Z"] = (createStoreSelectors);


/***/ }),

/***/ 17296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getAnimationPath; }
/* harmony export */ });
/*
  For the lottie animations that will be used across the site.
*/ // eslint-disable-next-line import/prefer-default-export
var getAnimationPath = function(animationPath) {
    return "/static/animations/".concat(animationPath);
};


/***/ }),

/***/ 51562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _actions_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68060);
/* harmony import */ var _stores_toggleables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85690);
/* harmony import */ var _stores_snackbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97296);
/* harmony import */ var _constants_toggleables__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28119);
/* harmony import */ var _actions_constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94336);
/* harmony import */ var _utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74392);
/* harmony import */ var _api_fetchers_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79415);
/* harmony import */ var _getTokens__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17912);
/* harmony import */ var _captureAPIFailure__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28029);













var isRefreshing = false;
var subscribers = [];
var fetchErrorHandler = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var error, _action, action, dispatch, getState, _rest, rest, options, headers, endpoint, source, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, accessToken, refreshToken, isServer, response, errorResp;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    error = param.error, _action = param.action, action = _action === void 0 ? {
                        type: ""
                    } : _action, dispatch = param.dispatch, getState = param.getState, _rest = param.rest, rest = _rest === void 0 ? {} : _rest, options = param.options, headers = param.headers, endpoint = param.endpoint, source = param.source;
                    ;
                    if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) >= 400 && (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) < 600) (0,_captureAPIFailure__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        endpoint: endpoint,
                        error: error,
                        source: source,
                        options: options,
                        headers: headers
                    });
                    if (!((error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 401)) {
                        _ctx.next = 35;
                        break;
                    }
                    ref7 = (0,_getTokens__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(getState), accessToken = ref7.accessToken, refreshToken = ref7.refreshToken;
                    isServer = "object" === "undefined";
                    if (!(accessToken && refreshToken)) {
                        _ctx.next = 34;
                        break;
                    }
                    if (isRefreshing) {
                        _ctx.next = 32;
                        break;
                    }
                    if (action.type !== "ME") subscribers.push(action);
                    isRefreshing = true;
                    _ctx.prev = 10;
                    _ctx.next = 13;
                    return (0,_api_fetchers_user__WEBPACK_IMPORTED_MODULE_6__/* .fetchNewToken */ .R$)(refreshToken);
                case 13:
                    _ctx.next = 15;
                    return _ctx.sent.json();
                case 15:
                    response = _ctx.sent;
                    if (!(response === null || response === void 0 ? void 0 : response.error)) {
                        _ctx.next = 18;
                        break;
                    }
                    throw new Error(response === null || response === void 0 ? void 0 : response.error);
                case 18:
                    isRefreshing = false;
                    dispatch((0,_actions_auth__WEBPACK_IMPORTED_MODULE_1__/* .authenticate */ .YR)({
                        accessToken: response.access_token,
                        refreshToken: response.refresh_token
                    }));
                    _ctx.next = 22;
                    return dispatch((0,_actions_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchMyInfo */ .ct)());
                case 22:
                    subscribers.forEach(function(cb) {
                        return dispatch(cb);
                    });
                    _ctx.next = 29;
                    break;
                case 25:
                    _ctx.prev = 25;
                    _ctx.t0 = _ctx["catch"](10);
                    if (!isServer) {
                        (0,_utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("", {
                            keepSelectedGoal: true
                        });
                        (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_2__/* .openToggleableElement */ .SL)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_10__/* .LOGIN_DRAWER */ .es);
                    }
                    dispatch({
                        type: "".concat(_actions_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .authTypes.ME */ .CK.ME, "_FAILURE")
                    });
                case 29:
                    _ctx.prev = 29;
                    subscribers = [];
                    return _ctx.finish(29);
                case 32:
                    _ctx.next = 35;
                    break;
                case 34:
                    {
                        if (!isServer) {
                            (0,_utils_signOutUser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("", {
                                keepSelectedGoal: true
                            });
                            (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_2__/* .openToggleableElement */ .SL)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_10__/* .LOGIN_DRAWER */ .es);
                        }
                        dispatch({
                            type: "".concat(_actions_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .authTypes.ME */ .CK.ME, "_FAILURE")
                        });
                    }
                case 35:
                    if ((error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 429) {
                        _stores_snackbar__WEBPACK_IMPORTED_MODULE_3__/* .utils.open */ .P6.open({
                            message: "Too many requests. Please try again after sometime.",
                            type: "error"
                        });
                    }
                    if (!((error === null || error === void 0 ? void 0 : (ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) >= 500 || error.status >= 500)) {
                        _ctx.next = 38;
                        break;
                    }
                    return _ctx.abrupt("return", dispatch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, rest), {
                        error: error,
                        type: "".concat(action.type, "_FAILURE")
                    })));
                case 38:
                    _ctx.next = 40;
                    return error === null || error === void 0 ? void 0 : (ref5 = error.response) === null || ref5 === void 0 ? void 0 : ref5.json();
                case 40:
                    errorResp = _ctx.sent;
                    return _ctx.abrupt("return", dispatch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, rest), {
                        error: errorResp,
                        type: "".concat(action.type, "_FAILURE"),
                        statusCode: error === null || error === void 0 ? void 0 : (ref6 = error.response) === null || ref6 === void 0 ? void 0 : ref6.status
                    })));
                case 42:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                10,
                25,
                29,
                32
            ]
        ]);
    }));
    return function fetchErrorHandler(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (fetchErrorHandler);


/***/ }),

/***/ 2477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var camelcase_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12828);
/* harmony import */ var camelcase_keys__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(camelcase_keys__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _checkAPIResponseStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89875);




/**
 * Fetch with response status check.
 * This function must be wrapped in a try/catch block to catch exceptions.
 * Being used in **worker** space as well.
 * @param {string} url
 * @param {object} options
 * @returns {*} any
 */ var fetchWithoutErrorHandling = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, options) {
        var ref, headers, _useCamelCase, useCamelCase, _hasTextResponse, hasTextResponse, _requestType, requestType, _isFormData, isFormData, _body, body, fetchOptions, response, resp;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = options || {}, headers = ref.headers, _useCamelCase = ref.useCamelCase, useCamelCase = _useCamelCase === void 0 ? false : _useCamelCase, _hasTextResponse = ref.hasTextResponse, hasTextResponse = _hasTextResponse === void 0 ? false : _hasTextResponse, _requestType = ref.requestType, requestType = _requestType === void 0 ? "GET" : _requestType, _isFormData = ref.isFormData, isFormData = _isFormData === void 0 ? false : _isFormData, _body = ref.body, body = _body === void 0 ? null : _body;
                    fetchOptions = {
                        method: requestType,
                        headers: headers || {},
                        credentials: "same-origin"
                    };
                    if (false) {}
                    if (body) {
                        try {
                            fetchOptions.body = isFormData ? body : JSON.stringify(body);
                        } catch (e) {
                        /* */ }
                    }
                    _ctx.next = 6;
                    return fetch(url, fetchOptions);
                case 6:
                    response = _ctx.sent;
                    (0,_checkAPIResponseStatus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(response);
                    if (!(response.status === 204)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", response);
                case 10:
                    ;
                    if (hasTextResponse) {
                        _ctx.next = 23;
                        break;
                    }
                    _ctx.prev = 12;
                    _ctx.next = 15;
                    return response.json();
                case 15:
                    resp = _ctx.sent;
                    if (useCamelCase) resp = camelcase_keys__WEBPACK_IMPORTED_MODULE_1___default()(resp, {
                        deep: true
                    });
                    _ctx.next = 21;
                    break;
                case 19:
                    _ctx.prev = 19;
                    _ctx.t0 = _ctx["catch"](12);
                case 21:
                    _ctx.next = 26;
                    break;
                case 23:
                    _ctx.next = 25;
                    return response.text();
                case 25:
                    resp = _ctx.sent;
                case 26:
                    return _ctx.abrupt("return", resp);
                case 27:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                12,
                19
            ]
        ]);
    }));
    return function fetchWithoutErrorHandling(url, options) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (fetchWithoutErrorHandling);


/***/ }),

/***/ 26951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54051);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34497);
/* harmony import */ var _utils_deviceHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97487);
/* harmony import */ var _getTokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17912);






var defaultHost = (0,_utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultHost */ .tW)();
var getHeaders = function(param) {
    var url = param.url, getState = param.getState, _headersOptions = param.headersOptions, _useAuthToken = _headersOptions.useAuthToken, useAuthToken = _useAuthToken === void 0 ? true : _useAuthToken, _useSearchToken = _headersOptions.useSearchToken, useSearchToken = _useSearchToken === void 0 ? false : _useSearchToken, _useJWTToken = _headersOptions.useJWTToken, useJWTToken = _useJWTToken === void 0 ? false : _useJWTToken, _isFormData = _headersOptions.isFormData, isFormData = _isFormData === void 0 ? false : _isFormData, _useStarGateToken = _headersOptions.useStarGateToken, useStarGateToken = _useStarGateToken === void 0 ? false : _useStarGateToken, headers = param.headers;
    var ref = (0,_getTokens__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(getState), accessToken = ref.accessToken, searchToken = ref.searchToken, JWTToken = ref.JWTToken;
    var apiCallHeaders = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, useAuthToken && accessToken ? {
        authorization: "Bearer ".concat(accessToken)
    } : "", useJWTToken && JWTToken ? {
        authorization: "Bearer ".concat(JWTToken)
    } : "", useSearchToken && searchToken ? {
        searchToken: "Bearer ".concat(searchToken)
    } : "", !isFormData && {
        "Content-Type": "application/json"
    }, headers || {});
    var isServer = "object" === "undefined";
    if (url.includes(defaultHost)) {
        var platform = !isServer && _utils_deviceHelper__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isMobile */ .Z.isMobile({
            isServer: isServer
        }) ? _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .PLATFORM.MOBILE */ .iw.MOBILE : _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .PLATFORM.OTHER */ .iw.OTHER;
        apiCallHeaders["X-Platform"] = platform;
    }
    if (useStarGateToken) {
        var stargateJWTToken = (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_2__/* .getStargateJwtToken */ .$1)(getState());
        apiCallHeaders["Stargate-Token"] = stargateJWTToken;
    }
    return apiCallHeaders;
};
/* harmony default export */ __webpack_exports__["Z"] = (getHeaders);


/***/ }),

/***/ 17912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18113);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34497);


var getTokens = function(getState) {
    var accessToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("accessToken", getState);
    var refreshToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("refreshToken", getState);
    if (true) {
        if (!accessToken) accessToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("accessToken");
        if (!refreshToken) refreshToken = _utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].readCookie */ .ZP.readCookie("refreshToken");
    }
    var searchToken = typeof getState === "function" ? (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getSearchToken */ .d6)(getState()) : "";
    var JWTToken = (0,_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getJwtToken */ .rS)(getState());
    return {
        accessToken: accessToken,
        refreshToken: refreshToken,
        searchToken: searchToken,
        JWTToken: JWTToken
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getTokens);


/***/ }),

/***/ 97903:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var getItemFromSessionStorage = function(item) {
    try {
        return sessionStorage.getItem(item);
    } catch (e) {
        return null;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getItemFromSessionStorage);


/***/ }),

/***/ 21848:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var parseNumber = function(value) {
    var radix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    return value && parseInt(value, radix) || 0;
};
/* harmony default export */ __webpack_exports__["Z"] = (parseNumber);


/***/ })

}]);